export default {
  text: {
    // auth
    "auth-otp-form-email-placeholder": "email@example.com",
    "auth-otp-form-button-continue-label": "continue",
    "auth-otp-form-email-sent-to": "We sent you a code to",
    "auth-otp-form-email-wrong-email": "wrong email?",
    "auth-otp-form-button-verify-label": "sign in",

    "version-check-new-version-available": "new version available",
    "version-check-reload": "reload",

    main_title: "Administration",

    "menu-cms": "cms",
    "menu-pages": "Pages",
    "menu-posts": "Posts",
    "menu-commerce": "Commerce",
    "menu-analytics": "Analytics",
    "menu-settings": "Settings",
    "menu-help": "Help",
    "menu-logout": "Logout",
    "menu-publisher": "Publisher",
    "menu-designer": "Designer",

    "sites-main-headline": "My Sites",

    "option-yes": "Yes",
    "option-no": "No",

    monthNames: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
    dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],

    "login-header": "Login",
    "login-header-label": "Proceed to login here...",
    "login-user-name": "User name",
    "login-user-password": "Password",
    "login-user-email": "E-mail",
    "login-submit-button": "Sign in",
    "login-help": "Need help?",
    "login-use-pwd": "use password",
    "login-use-pwdless": "use e-mail link",
    "login-use-passkey": "use Passkey",
    "login-msg-welcome": "platforma.one",
    "login-error-wrong-password": "Wrong password",
    "login-error-too-many-requests": "Too many attempts, try later.",
    "login-validator-passwordlessemail-errormessage-notvalid":
      "Not close enough. Misspelled smoething?",
    "login-validator-passwordlessemail-errormessage-notfound": "We didn't find you. Are you real?",
    "login-validator-passwordlessemail-errormessage-empty": "This is the place to put your e-mail.",
    "login-validator-passwordemail-errormessage-bad": "This",
    "login-validator-passwordemail-errormessage-empty": "Come on, be more specific.",
    "login-validator-passwordemail-errormessage-notvalid": "That's not an email!",
    "login-validator-password-errormessage-bad": "or that is not correct.",
    "login-validator-password-errormessage-empty": "Come on, passwords are important!",
    "login-email-instructions-headline": "Check your email",
    "login-email-sent-instructions-pt1": "Login email is on its way to",
    "login-email-sent-instructions-pt2": "",
    "login-email-sent-instructions-pt3": "You may close this window.",
    "login-email-instructions-tryagain": "Try again",

    "guest-signup-email-instructions-headline": "Wohoo, only one step away from your site!",
    "guest-signup-email-sent-instructions-pt1":
      "Confirmation link to publish your site was sent to",
    "guest-signup-email-sent-instructions-pt2":
      "You may close this window, new one will be opened from the link you will receive.",
    "guest-signup-published-headline": "It's on!",
    "guest-signup-published-text": "Your site is running live at",
    "guest-signup-published-open-btn": "Check it out",

    "main-site-menu": "Main menu",

    "settings-header": "Settings",
    "site-config-title": "Site title",

    "pages-header": "Pages",
    "pages-add-subpage": "Add subpage",
    "pages-stop-adding-subpage": "Finished adding subpage",
    "page-qr-code-generator-page-lang": "Language",
    "page-list": "Page list",
    "main-view-site": "View site",
    "page-selected-layout": "Layout",
    "page-selected-content": "Content",
    "page-selected-settings": "Settings",
    "page-selected-styles": "Styles",
    "page-setup-title": "Title",
    "page-setup-role": "Required role",
    "page-setup-description": "Desription",
    "page-setup-slugs": "URL",
    "page-setup-visible": "Visible",
    "page-button-delete": "Delete page",
    "page-add-hint": "Click a point to insert",
    "page-duplicate": "Duplicate",
    "page-duplicate-parent": "Parent page",
    "page-duplicate-new-title": "New page title",
    "page-duplicate-execute": "Make it so",
    "page-clone-fill_name": "Fill page name for language: ",
    "page-clone-parent_no_slug": "Parent page has no slug!",
    "page-clone-slag_for_lang": "Parent page has no slug for language: ",
    "page-clone-done": "Duplication completed.",
    "page-clone-error": "Duplication failed!",
    "page-block-styling": "Styling",
    "label-add-language-version": "Add language version",

    // editor
    "editor-blockForm-main-textWithHeader-form-header-label": "header",
    "editor-blockForm-main-textWithHeader-form-paragraph-label": "paragraph",
    "editor-blockForm-main-header-form-header-label": "header",
    "editor-blockForm-commerce-productListing-form-productDetailPage-label": "product page",
    "editor-blockForm-commerce-productListing-form-productDetailPage-caption":
      "product page that will be shown when product is clicked in the list",
    "editor-blockForm-commerce-productListing-form-filterByTags-label": "product filter",
    "editor-blockForm-commerce-productListing-form-filterByTags-caption":
      "tags of products to be be shown in this section",
    "editor-blockForm-commerce-productListing-form-sortBy-label": "sorting",
    "editor-blockForm-commerce-productListing-form-sortBy-option-title-label": "title",
    "editor-blockForm-commerce-productListing-form-sortBy-option-price-label": "price",
    "editor-blockForm-commerce-productListing-form-sortBy-option-dateUpdated-label": "date updated",
    "editor-blockForm-commerce-productListing-form-sortBy-option-dateCreated-label": "date created",
    "editor-blockForm-commerce-productListing-form-sortBy-option-availability-label":
      "availability",
    "editor-blockForm-commerce-productListing-form-sortBy-addField": "add another field",
    "editor-blockForm-commerce-productListing-form-limit-label": "limit the number of items",
    "editor-blockForm-commerce-productListing-form-showAllButton-label": "show 'more' button",
    "editor-blockForm-commerce-productListing-form-showItemsAvailable-label": "show available",
    "editor-blockForm-commerce-productListing-form-showItemsUnavailable-label": "show unavailable",
    "editor-blockForm-commerce-productListing-form-showItemsForPreorder-label": "show preorder",
    "editor-blockForm-commerce-productListing-form-showFilters-label": "show filters",

    "dashboard-coming-soon": "Dashboard coming soon",

    "generic-download": "Download",
    "commerce-generate-qr-code": "Generate QR code",
    "commerce-remove-variant": "Remove variant",
    "commerce-qr-code-generator-auto-add-to-cart": "Automatically add to cart",
    "commerce-qr-code-generator-delivery-method": "Delivery method",
    "commerce-qr-code-generator-hide-other-delivery-methods": "Hide other delivery methods",
    "commerce-order-name-anonymous": "no name",
    "commerce-order-item-giftcard-resendToCustomer": "resend to customer",
    "commerce-order-item-giftcard-resendToRecipient": "resend to recipient",
    "commerce-order-item-giftcard-download": "download",
    "commerce-header": "E-shop",
    "commerce-shop-name": "Shop name",
    "commerce-no-site": "Select the website first",
    "commerce-new-eshop": "Create new e-shop",
    "commerce-carts": "Carts",
    "commerce-orders": "Orders",
    "commerce-inventory": "Inventory",
    "commerce-shop-items": "Shop items",
    "commerce-customers": "Customers",
    "commerce-subscriptions": "Subscriptions",
    "commerce-orders-setup": "Settings",
    "commerce-export": "Export",
    "commerce-orders-flow-setup": "Order flow setup",
    "commerce-shop-create-model": "Create new product form specification",
    "commerce-shop-update-model": "Update product form specification",
    "commerce-products-header": "Products",
    "commerce-product-attr-name": "Field name",
    "commerce-product-model-name": "Product type name",
    "commerce-shop-create-product": "Create new product",
    "commerce-shop-update-product": "Update product details",
    "commerce-product-header": "Product",
    "commerce-fee-reports": "Fee reports",
    "commerce-fee-billing": "Billing",
    "product-created-info": "Product has been created.",
    "product-not-created-error": "A problem prevented product creation!",
    "product-saved-info": "Product has been updated.",
    "product-not-saved-error": "A problem prevented product alteration!",
    "product-question-delete": "Do you really want to remove the product (including variants)?",
    "product-image-main": "Main product",
    "product-image-variant": "Main variant",
    "product-fees": "Fees",
    "product-sku-already-exists": "SKU must be unique",
    "upload-file-in-process": "Upload in progress",
    "commerce-setup": "Commerce setup",
    "commerce-supported-curr": "Supported currencies",
    "commerce-default-curr": "Default currency",
    "commerce-supported-langs": "Supported languages",
    "commerce-default-lang": "Default language",
    "commerce-order-num-format": "Order number format",
    "commerce-order-num-format-hint": "...",
    "commerce-sell-units": "Possible sale units",
    "commerce-sell-units-hint": "...",
    "commerce-bank-connection": "Bank connection",
    "commerce-bank-name": "Bank name",
    "commerce-bank-code": "Bank code",
    "commerce-account-number": "Account number",
    "commerce-iban": "IBAN",
    "commerce-swift": "SWIFT",
    "commerce-company-address": "Company address",
    "commerce-setup-payments": "Payment setup",
    "commerce-payment-methods": "Payment methods",
    "commerce-payment-method-add": "Add another payment method",
    "commerce-delivery-planning-bulk-edit-enable": "Bulk edit",
    "commerce-delivery-planning-bulk-edit-disable": "Cancel bulk edit",
    "commerce-delivery-planning-delete-all": "Remove all",
    "commerce-tax-values": "Available tax values",
    "commerce-delivery-channels": "Supported delivery methods",
    "commerce-setup-deliveries": "Deliveries setup",
    "commerce-delivery-method-add": "Add another delivery method",
    "commerce-setup-delivery-planning-settings": "Delivery planning settings",
    "commerce-setup-delivery-planning": "Delivery planning",
    "commerce-delivery-next-day-order": "Last next-day order at:",
    "commerce-delivery-next-days": "Show next days:",
    "commerce-delivery-use-defaults": "Use defaults",
    "commerce-delivery-add-slot": "+ Add Slot",
    "commerce-delivery-additional-fields": "Additional cart form fields",
    "commerce-delivery-add-field": "+ Add field",
    "commerce-delivery-planning": "Delivery planning",
    "commerce-delivery-default-slots": "Slots template",
    "commerce-setup-delivery-planning-slots": "Active slots",
    "commerce-delivery-settings": "Settings",
    "commerce-delivery-point-title": "Delivery point",
    "commerce-flow-delete-error": "Not possible to delete state. It is used in: [%0]",
    "commerce-flow-cmd-set": "Set a value",
    "commerce-flow-cmd-exe": "Execute operation",
    "commerce-flow-operation-request-liftago": "Request Liftago",
    "commerce-flow-operation-zasilkovna-upload-to-zasilkovna": "Upload to Zasilkovna",
    "commerce-flow-operation-get-shipping-labels": "Print labels",
    "commerce-flow-operation-send-order-state-change-notification":
      "E-mail about order state change",
    "commerce-flow-check-equal": "Equal",
    "commerce-flow-check-not-equal": "Not Equal",
    "commerce-flow-check-contains": "Contains",
    "commerce-flow-check-not-contains": "Not contans",

    "commerce-order-tags-paid": "paid",
    "commerce-order-tags-unpaid": "unpaid",
    "commerce-order-tags-contactless": "contactless",

    "commerce-order-menu-markAsPaidManually": "Mark as paid manually",
    "commerce-order-menu-downloadInvoice": "Download invoice",
    "commerce-order-menu-sendInvoice": "Send invoice to customer",
    "commerce-order-menu-downloadRefundSlip": "Download refund slip",
    "commerce-order-menu-createRefundSlip": "Create refund slip",
    "commerce-order-menu-addPrivateNote": "Add private note",
    "commerce-order-menu-changeState": "Change state",
    "commerce-order-menu-sendEmail": "Send email to customer",
    "commerce-order-menu-openInFirestore": "Open in Firestore",
    "commerce-order-menu-openInFirestoreCart": "Open in Firestore (cart)",

    "commerce-orders-items-filter-order-state": "state",
    "commerce-orders-items-filter-delivery-method": "method",
    "commerce-orders-items-filter-delivery-branch": "branch",

    "commerce-orders-filter-title": "Filters",
    "commerce-orders-filter-payment-status": "Payment Status",
    "commerce-orders-filter-payment-paid": "Paid",
    "commerce-orders-filter-payment-unpaid": "Unpaid",
    "commerce-orders-filter-order-state": "Order State",
    "commerce-orders-filter-order-state-placeholder": "Select states",
    "commerce-orders-filter-delivery-method": "Delivery Method",
    "commerce-orders-filter-delivery-method-placeholder": "Select delivery methods",
    "commerce-orders-filter-delivery-branch": "Branch",
    "commerce-orders-filter-delivery-branch-placeholder": "Select branches",
    "commerce-orders-filter-slot-dates": "Slot Dates",
    "commerce-orders-filter-slot-date-from": "From",
    "commerce-orders-filter-slot-date-to": "To",
    "commerce-orders-filter-products": "Products",
    "commerce-orders-filter-products-placeholder": "Select products",
    "commerce-orders-filter-saved-filters": "Saved Filters",
    "commerce-orders-filter-reset": "Reset",
    "commerce-orders-filter-save": "Save",
    "commerce-orders-filter-close": "Close",
    "commerce-orders-filter-save-title": "Save Filter",
    "commerce-orders-filter-save-name-label": "Filter Name",
    "commerce-orders-filter-save-name-placeholder": "e.g. Christmas Bread 23. 12.",
    "commerce-orders-filter-save-button": "Save",
    "commerce-orders-filter-save-cancel": "Cancel",
    "commerce-orders-filter-saved": "Saved",
    "commerce-orders-filter-payment": "Payment",
    "commerce-orders-filter-fulfillment": "Fulfillment",
    "commerce-orders-filter-delivery": "Delivery",
    "commerce-orders-filter-slots": "Slots",
    "commerce-orders-filter-product": "Product",
    "commerce-orders-filter-button": "Filter",
    "commerce-orders-filter-button-with-count": "Filter [%0]",
    "commerce-orders-filter-button-with-name": "Filter [%0]",

    "commerce-orders-summary-button": "Summary",
    "commerce-orders-summary-title": "Summary",
    "commerce-orders-summary-orders": "Orders",
    "commerce-orders-summary-price": "Total Price",
    "commerce-orders-summary-products": "Products",
    "commerce-orders-summary-no-products": "No products in filtered orders",

    "commerce-orders-items-table-col-title": "title",
    "commerce-orders-items-table-col-item-count": "count",
    "commerce-orders-items-table-col-order-number": "order",
    "commerce-orders-items-table-col-order-price": "or. price",
    "commerce-orders-items-table-col-order-state": "state",
    "commerce-orders-items-table-col-delivery-method": "method",
    "commerce-orders-items-table-col-delivery-branch": "branch",
    "commerce-orders-items-table-col-delivery-slot": "slot",
    "commerce-orders-items-table-col-customer": "customer",
    "commerce-orders-items-table-col-payment": "payment",
    "commerce-orders-items-table-col-ordered-at": "ordered",

    "commerce-orders-send-email": "send email",
    "commerce-orders-change-state": "change state",
    "commerce-order-send-email-title-single": "send email to customer",
    "commerce-order-send-email-title-multiple": "send email to %0 customers",
    "commerce-order-send-email-mode": "mode",
    "commerce-order-send-email-mode-custom": "custom",
    "commerce-order-send-email-mode-template": "from template",
    "commerce-order-send-email-subject": "email subject",
    "commerce-order-send-email-body": "email body",
    "commerce-order-send-email-template": "template",
    "commerce-order-send-email-available-variables": "available variables",
    "commerce-order-send-email-preview": "preview",
    "commerce-order-send-email-will-send-to": "email will be sent to %0 order(s)",
    "commerce-order-send-email-send": "send",
    "commerce-order-send-email-send-multiple": "send to %0 orders",
    "commerce-order-send-email-cancel": "cancel",
    "email-sent-to-customer": "email sent to customer",

    "commerce-order-change-state-dialog-title-single": "change state for order",
    "commerce-order-change-state-dialog-title-multiple": "change state for %0 orders",
    "commerce-order-change-state-dialog-new-state-label": "new state",
    "commerce-order-change-state-dialog-will-change": "state will be changed for %0 order(s)",
    "commerce-order-change-state-dialog-save": "save",
    "commerce-order-change-state-dialog-save-confirm": "confirm",
    "commerce-order-change-state-dialog-cancel": "cancel",

    "commerce-email-template-table-col-name": "name",
    "commerce-email-template-table-col-description": "description",
    "commerce-email-template-add-button": "template",
    "commerce-email-template-form-title-add": "add template",
    "commerce-email-template-form-title-edit": "edit template",
    "commerce-email-template-form-name-label": "template name",
    "commerce-email-template-form-description-label": "template description",
    "commerce-email-template-form-email-section": "e-mail",
    "commerce-email-template-form-subject-label": "email subject",
    "commerce-email-template-form-subject-caption": "variables: {{variableName}}",
    "commerce-email-template-form-message-label": "email message",
    "commerce-email-template-form-message-caption": "variables: {{variableName}}",
    "commerce-email-template-form-available-variables": "available variables",
    "commerce-email-template-form-markdown-help":
      "supports markdown URL format: [link text](https://example.com)",
    "commerce-email-template-form-save": "save",
    "commerce-email-template-form-send-test": "send test",
    "commerce-email-template-form-cancel": "cancel",
    "commerce-email-template-form-preview": "preview",
    "commerce-email-template-form-test-dialog-title": "test send",
    "commerce-email-template-form-test-dialog-email-label": "email",
    "commerce-email-template-form-test-dialog-send": "send",
    "commerce-email-template-variable-orderNumber": "order number",
    "commerce-email-template-variable-orderDate": "order date",
    "commerce-email-template-variable-customerFirstName": "customer first name",
    "commerce-email-template-variable-customerLastName": "customer last name",
    "commerce-email-template-variable-customerFullName": "customer full name",
    "commerce-email-template-variable-deliveryMethodName": "delivery method name",
    "commerce-email-template-variable-branchName": "branch name",
    "commerce-email-template-variable-slotDateTime": "slot date and time",
    "commerce-email-template-variable-slotDate": "slot date",
    "commerce-email-template-variable-slotTime": "slot time",
    "commerce-email-template-variable-slotDaysRelative": "slot days relative",

    "commerce-price-brutto": "incl. VAT",
    "commerce-price-netto": "excl. VAT",
    "commerce-price-units": "units",
    "commerce-price-enter-without-vat": "enter price without VAT",
    "commerce-price-enter-with-vat": "enter price with VAT",
    "commerce-price-currency": "currency",
    "commerce-price-vat": "VAT",
    "commerce-price-initial": "Initial",

    "commerce-promo-codes": "Discount codes",
    "commerce-gift-cards": "Gift cards",
    "commerce-promocode-label": "Code",
    "commerce-promocode-codeslist": "Code list",
    "commerce-promocode-count": "Count of individual usage",
    "commerce-promocode-unit": "Unit",
    "commerce-promocode-value": "Value",
    "commerce-promocode-from": "Valid from",
    "commerce-promocode-to": "Valid to",
    "commerce-promocode-tags": "Tags",
    "commerce-promocode-note": "Note",
    "commerce-promocode-kind": "Kind",

    // commerce gift cards
    "commerce-giftcards-table-code": "Code",
    "commerce-giftcards-table-status": "Status",
    "commerce-giftcards-table-value": "Value",
    "commerce-giftcards-table-valueRemaining": "Balance",
    "commerce-giftcards-table-customerName": "Name",
    "commerce-giftcards-table-product": "Product",
    "commerce-giftcards-table-validFrom": "Valid from",
    "commerce-giftcards-table-validTo": "Valid to",
    "commerce-giftcards-table-purchasedIn": "Order",
    "commerce-giftcards-table-orderedAt": "Ordered at",
    "commerce-giftcards-table-usedAt": "Used at",
    "commerce-giftcards-table-usage": "Usage",
    "commerce-giftcards-table-createdAt": "Created",

    "commerce-giftcards-status-available": "Available",
    "commerce-giftcards-status-used": "Used",
    "commerce-giftcards-status-usedPartially": "Partially used",
    "commerce-giftcards-status-expired": "Expired",
    "commerce-giftcards-status-purchased": "Purchased",
    "commerce-giftcards-status-notPurchased": "Not purchased",

    "commerce-giftcards-details-allowedUsage-atStore": "at store",
    "commerce-giftcards-details-allowedUsage-eShop": "e-shop",
    "commerce-giftcards-details-allowedUsage-subtractable": "subtractable",
    "commerce-giftcards-details-history-col-label-amount": "amount",
    "commerce-giftcards-details-history-col-label-note": "note",
    "commerce-giftcards-details-history-col-label-date": "date",
    "commerce-giftcards-details-history-col-label-time": "time",
    "commerce-giftcards-details-valid": "valid",
    "commerce-giftcards-details-valueLeft": "value left",
    "commerce-giftcards-details-details": "details",
    "commerce-giftcards-details-allowedUsage": "allowed usage",
    "commerce-giftcards-details-validity-from": "valid from",
    "commerce-giftcards-details-validity-to": "valid to",
    "commerce-giftcards-details-history": "history",
    "commerce-giftcards-details-order": "order",
    "commerce-giftcards-details-transact": "transact",
    "commerce-giftcards-details-validate-amount": "amount",
    "commerce-giftcards-details-validate-privateNote": "private note",

    "commerce-giftcards-add-title": "New gift card",
    "commerce-giftcards-add-form-field-multiple-label": "count",
    "commerce-giftcards-add-form-field-multiple-option-single": "single",
    "commerce-giftcards-add-form-field-multiple-option-multiple": "multiple",
    "commerce-giftcards-add-form-field-code-label": "code",
    "commerce-giftcards-add-form-field-code-caption": "Any code, e.g. GC-2345456 or 42392004",
    "commerce-giftcards-add-form-field-codes-label": "code list",
    "commerce-giftcards-add-form-field-codes-caption": "Any codes separated by a new line.",
    "commerce-giftcards-add-form-field-value-label": "value",
    "commerce-giftcards-add-form-field-value-caption": "Any amount, e.g. 100 or 10000.00",
    "commerce-giftcards-add-form-field-usage-label": "allowed usage",
    "commerce-giftcards-add-form-field-allowOffline-label": "at store",
    "commerce-giftcards-add-form-field-allowOnline-label": "on e-shop",
    "commerce-giftcards-add-form-field-allowCredit-label": "subtractable (multiple usage)",
    "commerce-giftcards-add-form-field-validity-label": "validity",
    "commerce-giftcards-add-form-field-from-label": "from",
    "commerce-giftcards-add-form-field-from-caption": "shows timezone",
    "commerce-giftcards-add-form-field-to-label": "to",
    "commerce-giftcards-add-form-field-to-caption": "shows timezone",
    "commerce-giftcards-add-form-field-validity-presets-label": "preset",
    "commerce-giftcards-add-form-field-validity-presets-1m-label": "1 month",
    "commerce-giftcards-add-form-field-validity-presets-3m-label": "3 months",
    "commerce-giftcards-add-form-field-validity-presets-6m-label": "6 months",
    "commerce-giftcards-add-form-field-validity-presets-1y-label": "1 year",
    "commerce-giftcards-add-form-field-validity-presets-2y-label": "2 years",
    "commerce-giftcards-add-form-field-validity-presets-3y-label": "3 years",
    "commerce-giftcards-add-form-field-validity-presets-5y-label": "5 years",
    "commerce-giftcards-add-form-field-validity-presets-10y-label": "10 years",
    "commerce-giftcards-add-form-field-validity-presets-2099-label": "2099",
    "commerce-giftcards-add-form-field-customerName-label": "name",
    "commerce-giftcards-add-form-field-customerEmail-label": "email",
    "commerce-giftcards-add-form-field-customerPhone-label": "phone",
    "commerce-giftcards-add-form-field-note-label": "note",
    "commerce-giftcards-add-form-field-note-caption": "internal note, not visible to customers",
    "commerce-giftcards-add-form-action-save-label": "save",
    "commerce-giftcards-add-form-action-cancel-label": "cancel",

    "commerce-giftcards-transact-form-title": "Transaction",
    "commerce-giftcards-transact-form-direction-subtract": "subtract",
    "commerce-giftcards-transact-form-direction-add": "add",
    "commerce-giftcards-transact-form-amount-label": "amount",
    "commerce-giftcards-transact-form-amount-placeholder": "1000",
    "commerce-giftcards-transact-form-note-label": "note",
    "commerce-giftcards-transact-form-note-placeholder": "for order lala-123",
    "commerce-giftcards-transact-form-note-caption": "internal, not visible to customers",
    "commerce-giftcards-transact-form-actions-cancel-label": "cancel",
    "commerce-giftcards-transact-form-actions-transact-subtract-label": "subtract",
    "commerce-giftcards-transact-form-actions-transact-add-label": "add",
    "commerce-giftcards-transact-form-actions-transactConfirm-label": "confirm",

    // commerce setup
    // invoicing
    "commerce-setup-company-title-invoicing": "Invoicing",
    "commerce-setup-company-label-orderNumberFormat": "Order number format",

    // invoice info
    "commerce-setup-company-title-company": "Invoice info",
    "commerce-setup-company-label-name": "Company",
    "commerce-setup-company-label-ico": "IČO",
    "commerce-setup-company-label-dic": "DIČ",
    "commerce-setup-company-label-legalNote": "Note",

    // address
    "commerce-setup-company-label-street": "Street",
    "commerce-setup-company-label-streetNumber": "Street no.",
    "commerce-setup-company-label-city": "City",
    "commerce-setup-company-label-postal": "Postal",
    "commerce-setup-company-label-country": "Country",

    // banking
    "commerce-setup-company-label-bankName": "Bank name",
    "commerce-setup-company-label-bankCode": "Bank code",
    "commerce-setup-company-label-accountNumber": "Account number",
    "commerce-setup-company-label-iban": "IBAN",
    "commerce-setup-company-label-swift": "SWIFT",

    // contact
    "commerce-setup-company-label-phone": "Phone",
    "commerce-setup-company-label-email": "E-mail",

    "commerce-settings-general-shop-name": "Shop name",
    "commerce-settings-payment-taxes": "VAT [%]",

    "commerce-orders-hide-column": "Hide column",
    "commerce-orders-select-multiple": "Select orders",
    "commerce-orders-cancel-selection": "Cancel selection",
    "commerce-orders-select-all-column": "Select all in column",
    "commerce-orders-of-selected": "selected",
    "commerce-orders-of-all": "all",

    "commerce-courier-liftago-courierPosition": "Courier location",
    "commerce-courier-liftago-rideStatus-PROCESSING": "Looking for driver",
    "commerce-courier-liftago-rideStatus-ACCEPTED": "Driver selected",
    "commerce-courier-liftago-rideStatus-WAITING": "Driver awaiting pickup",
    "commerce-courier-liftago-rideStatus-IN_PROGRESS": "Items on board",
    "commerce-courier-liftago-rideStatus-COMPLETED": "Delivery finished",
    "commerce-courier-liftago-rideStatus-CANCELLED": "Delivery cancelled",
    "commerce-courier-liftago-rideStatus-REJECTED": "Couldn't find driver",
    "commerce-courier-liftago-stopState-IN_QUEUE": "In delivery",
    "commerce-courier-liftago-stopState-DELIVERED": "Delivered",
    "commerce-courier-liftago-stopState-UNDELIVERED": "Not delivered",
    "commerce-courier-liftago-handoverStatus-NEW": "Processed",
    "commerce-courier-liftago-handoverStatus-SCHEDULED": "Scheduled",
    "commerce-courier-liftago-handoverStatus-IN_RIDE": "Awaiting pickup",
    "commerce-courier-liftago-handoverStatus-ON_BOARD": "On board",
    "commerce-courier-liftago-handoverStatus-DELIVERING": "Delivering",
    "commerce-courier-liftago-handoverStatus-DELIVERED": "Delivered",
    "commerce-courier-liftago-handoverStatus-UNDELIVERED": "Undelivered",
    "commerce-courier-liftago-handoverStatus-RETURNING": "Returning",
    "commerce-courier-liftago-handoverStatus-RETURNED": "Returned",
    "commerce-courier-liftago-handoverStatus-CANCELED": "Canceled",
    "commerce-courier-liftago-handoverStatus-CANCELED_IN_RIDE": "Canceled during pickup",
    "commerce-courier-liftago-handoverStatus-CANCELED_WITH_POB": "Canceled after boarding",
    "commerce-courier-liftago-handoverStatus-CANCELED_BY_DRIVER": "Canceled by driver",
    "commerce-courier-liftago-handoverStatus-WONT_DELIVER": "Undeliverable",

    "commerce-override-detail-page": "Override detail page",
    "commerce-inventory-table-col-image": "image",
    "commerce-inventory-table-col-title": "title",
    "commerce-inventory-table-col-type": "typ",
    "commerce-inventory-table-col-type-option-main": "main",
    "commerce-inventory-table-col-type-option-variant": "variant",
    "commerce-inventory-table-col-sku": "SKU",
    "commerce-inventory-table-col-price": "price",
    "commerce-inventory-table-col-vat": "VAT",
    "commerce-inventory-table-col-stock-stocked": "in stock",
    "commerce-inventory-table-col-stock-available": "available",
    "commerce-inventory-table-col-stock-reserved": "reserved",
    "commerce-inventory-table-col-stock-blocked": "blocked",
    "commerce-inventory-table-col-tags": "tags",
    "commerce-inventory-table-col-delivery-methods": "delivery",
    "commerce-inventory-table-col-kind": "category",
    "commerce-inventory-table-col-kind-option-physical": "physical",
    "commerce-inventory-table-col-kind-option-virtual": "electronic",
    "commerce-inventory-table-col-kind-option-no-delivery": "no delivery",
    "commerce-inventory-table-col-subkind": "subcategory",
    "commerce-inventory-table-col-subkind-option-booking": "booking",
    "commerce-inventory-table-col-subkind-option-giftCard": "gift card",
    "commerce-inventory-table-col-subkind-option-video-on-demand": "video on demand",
    "commerce-inventory-table-col-subkind-option-digital-product": "digital product",
    "commerce-inventory-table-col-visibility": "visibility",
    "commerce-inventory-table-col-visibility-option-auto": "by stock",
    "commerce-inventory-table-col-visibility-option-available": "available",
    "commerce-inventory-table-col-visibility-option-unavailable": "unavailable",
    "commerce-inventory-table-col-visibility-option-preorder": "preorder",
    "commerce-inventory-table-col-visibility-option-hide": "hidden",
    "commerce-inventory-table-col-whenUnavailable": "visibility sold out",
    "commerce-inventory-table-col-whenUnavailable-option-restrict": "disable",
    "commerce-inventory-table-col-whenUnavailable-option-preorder": "preorder",
    "commerce-inventory-table-col-whenUnavailable-option-hide": "hide",
    "commerce-inventory-table-col-created": "created",
    "commerce-inventory-table-col-updated": "updated",
    "commerce-inventory-price-kind-option-fixed": "fixed",
    "commerce-inventory-price-kind-option-package": "package",
    "commerce-inventory-price-kind-option-voluntary": "voluntary",
    "commerce-inventory-images-panel-variant-label": "variant",
    "commerce-inventory-images-panel-listing-label": "listing",
    "commerce-inventory-panel-settings-allowDispatchToCustomer-label": "allow dispatch to customer",
    "commerce-inventory-panel-settings-allowDispatchToRecipient-label":
      "allow dispatch to recipient",
    "commerce-inventory-panel-settings-giftCardTitle-label": "display",
    "commerce-inventory-panel-settings-giftCardTitle-option-amount": "amount",
    "commerce-inventory-panel-settings-giftCardTitle-option-product": "product",
    "commerce-inventory-panel-settings-pdf-title-label": "title",
    "commerce-inventory-panel-settings-pdf-subtitle-label": "subtitle",
    "commerce-inventory-panel-settings-pdf-description-label": "service/product description",
    "commerce-inventory-panel-settings-pdf-contactLine1-label": "contact line 1",
    "commerce-inventory-panel-settings-pdf-contactLine2-label": "contact line 2",
    "commerce-inventory-panel-settings-giftCardCodeKind-label": "code kind",
    "commerce-inventory-panel-settings-giftCardCodeKind-option-auto": "auto",
    "commerce-inventory-panel-settings-giftCardCodeKind-option-predefined": "from list",
    "commerce-inventory-panel-settings-giftCardCodeKind-predefined-warning":
      "Don't forget to add your own codes in the Promo codes section",
    "commerce-inventory-panel-settings-giftCardCodeKind-expirationKind-label": "validity",
    "commerce-inventory-panel-settings-giftCardCodeKind-expirationKind-option-fixed": "fixed",
    "commerce-inventory-panel-settings-giftCardCodeKind-expirationKind-option-floating": "floating",
    "commerce-inventory-panel-settings-giftCardCodeKind-expirationKind-option-preset": "from list",
    "commerce-inventory-panel-settings-giftCardUsage-label": "usage",
    "commerce-inventory-panel-settings-giftCardUsage-option-offline":
      "allow offline use (at store)",
    "commerce-inventory-panel-settings-giftCardUsage-option-online": "allow online use (on e-shop)",
    "commerce-inventory-panel-settings-giftCardUsage-option-credit":
      "allow to use multiple times (subtractable)",
    "commerce-inventory-panel-settings-giftCardUsage-option-expirationKind-label": "validity",
    "commerce-inventory-panel-settings-giftCardUsage-option-expirationKind-option-fixed": "fixed",
    "commerce-inventory-panel-settings-giftCardUsage-option-expirationKind-option-floating":
      "floating",
    "commerce-inventory-panel-settings-giftCardDaysValidFromPurchase-label":
      "days valid from purchase",
    "commerce-inventory-panel-settings-giftCardBonus-label": "bonus",
    "commerce-inventory-panel-settings-giftCardBonus-description":
      "Bonus amount to be added to the gift card balance when the order is paid. (eg. sell for 100 with bonus 55 -> customer will get 155). Voucher will show 155 (if display is set to amount).",

    // identity: companies
    "identity-companies-col-label-name": "name",
    "identity-companies-col-label-created": "created",
    "identity-companies-col-label-updated": "updated",
    "identity-companies-add-form-title": "New company",
    "identity-companies-add-form-field-name-label": "name",
    "identity-companies-add-form-field-note-label": "note",
    "identity-companies-add-form-field-note-caption": "internal, not visible to customers",
    "identity-companies-add-form-action-save-label": "save",
    "identity-companies-add-form-action-cancel-label": "cancel",

    // identity: persons
    "identity-persons-col-label-nameFirst": "first name",
    "identity-persons-col-label-nameLast": "last name",
    "identity-persons-col-label-email": "e-mail",
    "identity-persons-col-label-phone": "phone",
    "identity-persons-col-label-birthday": "birthday",
    "identity-persons-col-label-stampCards": "stamp cards",
    "identity-persons-col-label-receiveNews": "receive news",
    "identity-persons-col-label-created": "created",
    "identity-persons-col-label-updated": "updated",
    "identity-persons-add-form-title": "New person",
    "identity-persons-add-form-field-nameFirst-label": "first name",
    "identity-persons-add-form-field-nameLast-label": "last name",
    "identity-persons-add-form-field-email-label": "e-mail",
    "identity-persons-add-form-field-phone-label": "phone",
    "identity-persons-add-form-field-birthday-label": "birthday",
    "identity-persons-add-form-field-cashbacks-label": "cashbacks",
    "identity-persons-add-form-field-receiveNews-label": "receive news",
    "identity-persons-add-form-field-companies-label": "companies",
    "identity-persons-add-form-field-note-label": "note",
    "identity-persons-add-form-field-note-caption": "internal, not visible to customers",
    "identity-persons-add-form-action-save-label": "save",
    "identity-persons-add-form-action-cancel-label": "cancel",
    "identity-persons-detail-edit-label": "edit",
    "identity-persons-detail-discounts-label": "discounts",
    "identity-persons-detail-discounts-none": "no discounts assigned",
    "identity-persons-detail-cashbacks-label": "cashbacks",
    "identity-persons-detail-cashbacks-none": "no cashbacks assigned",
    "identity-persons-detail-topup-bonuses-label": "topup bonuses",
    "identity-persons-detail-topup-bonuses-none": "no topup bonuses assigned",
    "identity-persons-detail-entitlements-label": "entitlements",
    "identity-persons-detail-entitlements-none": "no entitlements linked",

    "list-overview-count": "count",
    "list-overview-count-selected": "count (selected)",

    // balance
    "balance-balances-overview-total-available": "total available",
    "balance-balances-overview-lifetime-credit": "lifetime credit",
    "balance-balances-overview-lifetime-debit": "lifetime debit",
    "balance-balances-col-label-name": "name",
    "balance-balances-col-label-balanceGroupId": "group",
    "balance-balances-col-label-company": "company",
    "balance-balances-col-label-persons": "persons",
    "balance-balances-col-label-available": "available",
    "balance-balances-col-label-currency": "currency",
    "balance-balances-col-label-status": "status",
    "balance-balances-col-label-allowCredit": "credit",
    "balance-balances-col-label-allowDebit": "debit",
    "balance-balances-col-label-allowDebitPartial": "debit partial",
    "balance-balances-col-label-lifetimeCredit": "lifetime credit",
    "balance-balances-col-label-lifetimeDebit": "lifetime debit",
    "balance-balances-col-label-ruleLimits": "limits",
    "balance-balances-col-label-ruleChannels": "channels",
    "balance-balances-col-label-activeFrom": "active from",
    "balance-balances-col-label-activeTo": "active to",
    "balance-balances-col-label-created": "created",
    "balance-balances-col-label-updated": "updated",
    "balance-balances-filter-title": "Filter balances",
    "balance-balances-filter-created-from": "Created from",
    "balance-balances-filter-created-to": "Created to",
    "balance-balances-filter-button": "Filter",
    "balance-balances-col-value-status-inactive": "inactive",
    "balance-balances-col-value-status-active": "active",
    "balance-balances-col-value-status-locked": "locked",
    "balance-balances-col-value-status-suspended": "suspended",
    "balance-balances-col-value-status-expired": "expired",
    "balance-balances-col-value-status-closed": "closed",
    "balance-balance-detail-overview-available-label": "available",
    "balance-balance-detail-overview-lifetime-credit-label": "lifetime +",
    "balance-balance-detail-overview-lifetime-debit-label": "lifetime -",
    "balance-balance-detail-overview-currency-label": "ccy",
    "balance-balance-detail-overview-persons-label": "persons",
    "balance-balance-detail-overview-active-from": "active from",
    "balance-balance-detail-overview-active-to": "active to",
    "balance-balance-detail-overview-capabilities-label": "capabilities",
    "balance-balance-detail-overview-capabilities-allowCredit-label": "credit",
    "balance-balance-detail-overview-capabilities-allowDebit-label": "debit",
    "balance-balance-detail-overview-capabilities-allowDebitPartial-label": "debit partial",
    "balance-balance-detail-overview-merchantNote-label": "notes",
    "balance-balance-detail-overview-ruleLimits-label": "limits",
    "balance-balance-detail-overview-ruleLimits-noLimits": "no limits",
    "balance-balance-detail-overview-ruleLimits-table-col-type": "type",
    "balance-balance-detail-overview-ruleLimits-table-col-period": "period",
    "balance-balance-detail-overview-ruleLimits-table-col-amountMin": "min",
    "balance-balance-detail-overview-ruleLimits-table-col-amountMax": "max",
    "balance-balance-detail-overview-ruleLimits-table-col-setter": "setter",
    "balance-balance-detail-overview-ruleLimits-table-row-setter-merchant": "merchant",
    "balance-balance-detail-overview-ruleLimits-table-row-setter-customer": "customer",
    "balance-balance-detail-overview-ruleChannels-label": "channels",
    "balance-balance-detail-overview-ruleChannels-noChannels":
      "⚠️ no channels - debits possible only in admin",
    "balance-balance-detail-overview-entitlements-label": "entitlements",
    "balance-balance-detail-transactions-label": "transactions",
    "balance-balance-detail-transactions-expiration-adjustment-note": "Expired credit",
    "balance-balance-detail-transactions-created-by-system": "System",

    "balance-balance-detail-history-label": "history",
    "balance-balance-detail-history-action-active_to_change": "active to changed",
    "balance-balance-detail-history-action-active_from_change": "active from changed",
    "balance-balance-detail-history-action-status_change": "status changed",

    "balance-balance-detail-dialog-active-to-title": "Change active to",
    "balance-balance-detail-dialog-active-to-field-label": "active to",
    "balance-balance-detail-dialog-active-to-end-of-day-label": "end of day",
    "balance-balance-detail-dialog-active-to-button-confirm-label": "confirm",
    "balance-balance-detail-dialog-active-to-note-merchant-label": "note",
    "balance-balance-detail-dialog-active-to-note-merchant-placeholder": "reason for extension",
    "balance-balance-detail-dialog-active-to-note-merchant-caption": "internal, not visible to customers",
    "balance-balance-detail-dialog-active-to-note-customer-label": "note for customer",
    "balance-balance-detail-dialog-active-to-note-customer-placeholder": "extended per your request",
    "balance-balance-detail-dialog-active-to-note-customer-caption": "visible to customer",
    "balance-balance-detail-dialog-active-to-note-platform-label": "platform note",
    "balance-balance-detail-dialog-active-to-note-platform-placeholder": "internal",
    "balance-balance-detail-dialog-active-to-note-platform-caption": "platform admins only",
    "balance-balance-detail-dialog-active-to-reactivate-hint-expired": "Expired — reactivate?",
    "balance-balance-detail-dialog-active-to-reactivate-hint-inactive": "Not activated — activate?",
    "balance-balance-detail-dialog-active-to-reactivate-switch-label": "reactivate",
    "balance-balance-detail-history-note-platform-label": "platform note",

    "balance-balance-detail-dialog-status-title": "Change status",
    "balance-balance-detail-dialog-status-button-cancel-label": "cancel",
    "balance-balance-detail-dialog-status-button-save-label": "set",

    "balance-add-form-group-title": "Create balance group",
    "balance-add-form-single-title": "Create balance",
    "balance-add-form-group-description":
      "Balance groups are used to group balances together. Entitlements (Mobile Passes, Vouchers) are linked to balance groups. Customers are issued Entitlements, so they can spend from multiple balances at once.",
    "balance-add-form-single-description":
      "Entitlements (Mobile Passes, Vouchers) are linked to balance. Customers are issued Entitlements.",
    "balance-add-form-balances-group-label": "Balances",
    "balance-add-form-balances-group-item-label": "Balance",
    "balance-add-form-balances-group-add": "Balance",
    "balance-add-form-balances-group-caption": "Balances are ordered by debit priority",
    "balance-add-form-linkPerson-button-label": "Link Person",
    "balance-add-form-linkPerson-button-caption-group":
      "Select Person that will be able to spend from this Balance Group. This is typically your customer.",
    "balance-add-form-linkPerson-button-caption-single":
      "Select Person that will be able to spend from this Balance. This is typically your customer.",
    "balance-add-form-linkPerson-select-label": "Person",
    "balance-add-form-linkPerson-select-option-label-add": "New person",
    "balance-add-form-displayCode-label": "Display code after creating balance",
    "balance-add-form-created-code-dialog-title": "Created code",
    "balance-add-form-created-code-dialog-button-close-label": "Close",
    "balance-add-form-entitlements-heading": "Entitlements",
    "balance-add-form-entitlements-description":
      "Issue Entitlements that enable selected Person to spend from this Balance Group.",
    "balance-add-form-entitlements-online-label": "Online",
    "balance-add-form-entitlements-online-caption":
      "Customer area on your website (requires person)",
    "balance-add-form-entitlements-card-label": "Card",
    "balance-add-form-entitlements-card-caption": "Physical card",
    "balance-add-form-entitlements-pass-label": "Pass",
    "balance-add-form-entitlements-pass-caption": "Apple / Google Wallet pass (requires person)",
    "balance-add-form-entitlements-voucher-label": "Voucher",
    "balance-add-form-entitlements-voucher-caption": "PDF voucher",
    "balance-add-form-entitlements-provideCustomCode-label": "Custom code",
    "balance-add-form-entitlements-voucherTemplate-label": "Template",
    "balance-add-form-entitlements-provideCustomCode-caption":
      "Provide custom code for the Entitlement",
    "balance-add-form-entitlements-customCode-caption":
      "8+ char mix of A-Z0-9 recommended. No spaces or special chars.",
    "balance-add-form-entitlements-dispatch-label": "Send via e-mail",
    "balance-add-form-entitlements-dispatch-caption":
      "Send Entitlements to selected Person via e-mail after creation. (requires person)",
    "balance-add-form-balance-heading": "Balance",
    "balance-add-form-balance-form-status-label": "Status",
    "balance-add-form-balance-form-status-option-inactive-label": "Inactive",
    "balance-add-form-balance-form-status-option-active-label": "Active",
    "balance-add-form-balance-form-status-option-locked-label": "Locked",
    "balance-add-form-balance-form-status-option-suspended-label": "Suspended",
    "balance-add-form-balance-form-status-option-expired-label": "Expired",
    "balance-add-form-balance-form-status-option-closed-label": "Closed",
    "balance-add-form-balance-form-linkCompany-button-label": "Link Company",
    "balance-add-form-balance-form-linkCompany-button-caption":
      "For your reference, if this balance is related to a Company (e.g. your B2B client)",
    "balance-add-form-balance-form-linkCompany-select-label": "Company",
    "balance-add-form-balance-form-linkCompany-select-option-label-add": "New company",
    "balance-add-form-balance-form-nameCustomer-label": "Name for customer",
    "balance-add-form-balance-form-nameCustomer-placeholder": "Work",
    "balance-add-form-balance-form-nameCustomer-caption":
      "For customer's reference - what they see in the app.",
    "balance-add-form-balance-form-nameMerchant-label": "Name",
    "balance-add-form-balance-form-nameMerchant-placeholder": "GoodCompany llc.",
    "balance-add-form-balance-form-nameMerchant-caption": "Internal, not visible to customer",
    "balance-add-form-balance-form-activePeriod-label": "Active",
    "balance-add-form-balance-form-activePeriod-caption": "Validity since activation",
    "balance-add-form-balance-form-validityPeriod-label": "Validity",
    "balance-add-form-balance-form-validityPeriod-caption": "Validity starts at activation",
    "balance-add-form-balance-form-activeFrom-label": "From",
    "balance-add-form-balance-form-activeFrom-caption": "showing balance timezone",
    "balance-add-form-balance-form-activeTo-label": "To",
    "balance-add-form-balance-form-activeTo-caption": "showing balance timezone",

    "balance-add-form-balance-form-capabilities-heading": "Capabilities",
    "balance-add-form-balance-form-capabilities-allowCredit-label": "Crediting",
    "balance-add-form-balance-form-capabilities-allowCredit-caption": "Allow crediting of balance",
    "balance-add-form-balance-form-capabilities-allowDebit-label": "Debiting",
    "balance-add-form-balance-form-capabilities-allowDebit-caption": "Allow debiting of balance",
    "balance-add-form-balance-form-capabilities-allowDebitPartial-label": "Partial",
    "balance-add-form-balance-form-capabilities-allowDebitPartial-caption":
      "Balance can be debited multiple times",

    "balance-add-form-balance-form-channels-label": "Channels",
    "balance-add-form-balance-form-channels-caption":
      "Select channels where this balance can be used",
    "balance-add-form-balance-form-limits-heading": "Limits",
    "balance-add-form-balance-form-limits-form-type-label": "Type",
    "balance-add-form-balance-form-limits-form-type-option-credit-label": "Credit",
    "balance-add-form-balance-form-limits-form-type-option-debit-label": "Debit",
    "balance-add-form-balance-form-limits-form-type-option-expiration_adjustment-label":
      "Expiration adjustment",
    "balance-add-form-balance-form-limits-form-period-label": "Period",
    "balance-add-form-balance-form-limits-form-period-option-lifetime-label": "Daily",
    "balance-add-form-balance-form-limits-form-period-option-year-label": "Year",
    "balance-add-form-balance-form-limits-form-period-option-month-label": "Month",
    "balance-add-form-balance-form-limits-form-period-option-week-label": "Week",
    "balance-add-form-balance-form-limits-form-period-option-day-label": "Day",
    "balance-add-form-balance-form-limits-form-period-option-hour-label": "Hour",
    "balance-add-form-balance-form-limits-form-period-option-balance_available-label":
      "Balance available",
    "balance-add-form-balance-form-limits-form-period-option-transaction-label": "Transaction",
    "balance-add-form-balance-form-limits-form-amountMin-label": "Min",
    "balance-add-form-balance-form-limits-form-amountMin-placeholder": "0",
    "balance-add-form-balance-form-limits-form-amountMax-label": "Max",
    "balance-add-form-balance-form-limits-form-amountMax-placeholder": "1000",
    "balance-add-form-balance-form-limits-form-actions-add-label": "add",
    "balance-add-form-balance-form-limits-form-actions-remove-label": "remove",
    "balance-add-form-balance-form-available-label": "Amount",
    "balance-add-form-balance-form-amount-mode-label": "Amount",
    "balance-add-form-balance-form-amount-mode-option-flexible-label": "Flexible",
    "balance-add-form-balance-form-amount-mode-option-flexible-caption": "Set at activation time",
    "balance-add-form-balance-form-amount-mode-option-fixed-label": "Fixed",
    "balance-add-form-balance-form-transactionDescription-label": "Transaction description",
    "balance-add-form-balance-form-transactionDescription-placeholder":
      "Yearly cafeteria allowance",
    "balance-add-form-balance-form-transactionDescription-caption":
      "Appears in transaction history",
    "balance-add-form-balance-form-note-label": "Note",
    "balance-add-form-balance-form-note-caption": "Internal, not visible to customers",
    "balance-add-form-balance-form-actions-save-label": "save",
    "balance-add-form-balance-form-actions-cancel-label": "cancel",
    "balance-add-form-balance-form-actions-cancel-label-confirm": "confirm",

    "balance-add-form-actions-create-label": "create",
    "balance-add-form-actions-cancel-label": "cancel",

    "balance-transact-form-title": "Transaction",
    "balance-transact-form-status-inactive-label": "inactive",
    "balance-transact-form-status-active-label": "active",
    "balance-transact-form-status-locked-label": "locked",
    "balance-transact-form-status-suspended-label": "suspended",
    "balance-transact-form-status-expired-label": "expired",
    "balance-transact-form-status-closed-label": "closed",
    "balance-transact-form-type-debit": "debit",
    "balance-transact-form-type-credit": "credit",
    "balance-transact-form-amount-label": "amount",
    "balance-transact-form-amount-placeholder": "1000",
    "balance-transact-form-description-label": "description",
    "balance-transact-form-description-placeholder": "for order lala-123",
    "balance-transact-form-description-caption": "shared with customer",
    "balance-transact-form-note-merchant-label": "note",
    "balance-transact-form-note-merchant-placeholder": "agreed with boss on 2025-01-01",
    "balance-transact-form-note-merchant-caption": "internal, not visible to customers",
    "balance-transact-form-actions-cancel-label": "cancel",
    "balance-transact-form-actions-transact-debit-label": "debit",
    "balance-transact-form-actions-transact-credit-label": "credit",
    "balance-transact-form-actions-transactConfirm-label": "confirm",
    "balance-transact-form-bulk-header-count": "%0 balances selected",
    "balance-transact-form-bulk-header-total": "Total",
    "balance-balances-bulk-transact-button": "Bulk Transaction",
    "balance-transact-form-bulk-success": "Transaction completed on %0 balances",

    "balance-activate-form-title": "Activation",
    "balance-activate-form-status-inactive-label": "inactive",
    "balance-activate-form-status-active-label": "active",
    "balance-activate-form-status-locked-label": "locked",
    "balance-activate-form-status-suspended-label": "suspended",
    "balance-activate-form-status-expired-label": "expired",
    "balance-activate-form-status-closed-label": "closed",
    "balance-activate-form-amount-label": "amount",
    "balance-activate-form-amount-placeholder": "1000",
    "balance-activate-form-description-label": "description",
    "balance-activate-form-description-placeholder": "for order lala-123",
    "balance-activate-form-description-caption": "shared with customer",
    "balance-activate-form-note-merchant-label": "note",
    "balance-activate-form-note-merchant-placeholder": "agreed with boss on 2025-01-01",
    "balance-activate-form-note-merchant-caption": "internal, not visible to customers",
    "balance-activate-form-active-to-label": "active to",
    "balance-activate-form-active-to-placeholder": "select date",
    "balance-activate-form-active-to-caption": "expiration date and time",
    "balance-activate-form-actions-transact-activate-label": "activate",
    "balance-activate-form-actions-transactConfirm-label": "confirm",
    "balance-activate-form-actions-cancel-label": "cancel",

    "booking-status-awaiting_payment": "awaiting payment",
    "booking-status-awaiting_confirmation": "awaiting confirmation",
    "booking-status-confirmed": "confirmed",
    "booking-status-in_progress": "in progress",
    "booking-status-completed": "completed",
    "booking-status-no_show": "no show",
    "booking-status-cancelled": "cancelled",

    "booking-resources-add-label": "resource",
    "booking-resources-table-col-name": "name",
    "booking-resources-table-col-type": "type",
    "booking-resources-table-col-timezone": "timezone",

    "booking-resources-add-form-field-name-label": "name",
    "booking-resources-add-form-field-name-caption":
      "room or person name where or whom with the service is fulfilled. for internal reference, not visible to customers.",
    "booking-resources-add-form-field-type-label": "type",
    "booking-resources-add-form-field-type-option-venue-label": "venue",
    "booking-resources-add-form-field-type-option-person-label": "person",
    "booking-resources-add-form-field-timezone-label": "timezone",
    "booking-resources-add-form-action-save-label": "save",
    "booking-resources-add-form-action-cancel-label": "cancel",

    "booking-services-add-button-label": "service",
    "booking-services-table-col-name": "name",
    "booking-services-table-col-duration": "duration (min)",
    "booking-services-table-col-paid": "paid",
    "booking-services-table-col-description": "description",

    "booking-services-add-form-field-name-label": "name",
    "booking-services-add-form-field-name-caption":
      "for internal reference, not visible to customers",
    "booking-services-add-form-field-description-label": "description",
    "booking-services-add-form-field-description-caption":
      "for internal reference, not visible to customers",
    "booking-services-add-form-field-duration-label": "duration (min)",
    "booking-services-add-form-field-duration-caption":
      "used for prefilling slot length when planning",
    "booking-services-add-form-field-paid-label": "paid",
    "booking-services-add-form-action-save-label": "save",
    "booking-services-add-form-action-cancel-label": "cancel",

    "booking-slots-add-button-label": "slot",
    "booking-slots-table-col-date": "date",
    "booking-slots-table-col-start": "start",
    "booking-slots-table-col-end": "end",
    "booking-slots-table-col-capacity": "capacity",
    "booking-slots-table-col-remaining": "remaining",
    "booking-slots-table-col-reservations": "reservations",
    "booking-slots-table-col-capacity-limited-by": "capacity limited by",
    "booking-slots-table-col-resource": "resource",
    "booking-slots-table-col-services": "services",
    "booking-slots-table-col-capacity-limited-by-option-count": "count",
    "booking-slots-table-col-capacity-limited-by-option-minutes": "minutes",

    "booking-slots-form-field-has-reservations-caption":
      "Slot has reservations -> only total capacity can be modified.",
    "booking-slots-form-field-resource-label": "resource",
    "booking-slots-form-field-start-label": "start",
    "booking-slots-form-field-start-caption": "showing resource timezone",
    "booking-slots-form-field-end-label": "end",
    "booking-slots-form-field-end-caption": "showing resource timezone",
    "booking-slots-form-field-capacity-limited-by-label": "capacity limited by",
    "booking-slots-form-field-capacity-limited-by-option-count": "count",
    "booking-slots-form-field-capacity-limited-by-option-minutes": "minutes",
    "booking-slots-form-field-services-label": "services",
    "booking-slots-form-field-services-caption": "services that can allocate this slot",
    "booking-slots-form-field-capacity-label": "capacity",
    "booking-slots-form-action-save-label": "save",
    "booking-slots-form-action-cancel-label": "cancel",

    "booking-reservations-add-button-label": "reservation",
    "booking-reservations-send-reminder-button-label": "send reminder",
    "booking-reservations-send-reminder-button-label-secondary": "confirm",
    "booking-reservations-change-status-button-label": "change status",
    "booking-reservations-change-status-dialog-title": "change status",
    "booking-reservations-change-status-dialog-button-label": "change",
    "booking-reservations-table-col-name": "name",
    "booking-reservations-table-col-code": "code",
    "booking-reservations-table-col-capacity": "capacity",
    "booking-reservations-table-col-status": "status",
    "booking-reservations-table-col-service": "service",
    "booking-reservations-table-col-date": "date",
    "booking-reservations-table-col-slot": "slot",
    "booking-reservations-table-col-email": "e-mail",
    "booking-reservations-table-col-phone": "phone",
    "booking-reservations-table-col-customer-note": "customer note",
    "booking-reservations-table-col-extra": "extra",

    "booking-reservations-form-field-service-label": "service",
    "booking-reservations-form-field-slot-label": "slot",
    "booking-reservations-form-field-status-label": "status",
    "booking-reservations-form-field-capacity-label": "capacity",
    "booking-reservations-form-field-customer-name-label": "customer name",
    "booking-reservations-form-field-customer-email-label": "e-mail",
    "booking-reservations-form-field-customer-phone-label": "phone",
    "booking-reservations-form-field-confirmed-by-vendor-label": "confirmed by vendor",
    "booking-reservations-form-field-confirmed-by-vendor-caption":
      "reservation is considered confirmed from your side",
    "booking-reservations-form-field-confirmed-by-customer-label": "confirmed by customer",
    "booking-reservations-form-field-confirmed-by-customer-caption":
      "Reservation is considered confirmed from customer's side. When bought though e-shop, this is after payment.",
    "booking-reservations-form-field-customer-note-label": "customer note",
    "booking-reservations-form-field-customer-note-caption": "customer's requests",
    "booking-reservations-form-field-internal-note-label": "internal note",
    "booking-reservations-form-field-internal-note-caption": "not visible to customer",
    "booking-reservations-form-field-preferred-language-label": "preferred language",
    "booking-reservations-form-field-all-guests-are-adults-label": "all guests are adults",
    "booking-reservations-form-action-save-label": "save",
    "booking-reservations-form-action-cancel-label": "cancel",

    "billing-transactions-list-category-usage": "usage",
    "billing-transactions-list-category-top_up": "top-up",
    "billing-balance-available-label": "balance available",
    "billing-balance-top-up-title": "top-up",
    "billing-balance-top-up-button-label": "top-up",
    "billing-balance-top-up-amount-label": "amount",
    "billing-balance-top-up-amount-placeholder": "1000",
    "billing-balance-top-up-amount-caption": "CZK",
    "billing-balance-top-up-amount-currency": "CZK",
    "billing-balance-top-up-amount-currency-placeholder": "CZK",
    "billing-balance-top-up-amount-currency-caption": "CZK",
    "billing-balance-available-after-label": "available after",
    "billing-balance-top-up-payment-message":
      "We use Stripe to process payments. Your card is not stored with us.",
    "billing-balance-top-up-invoice-notice":
      "Topped up amount will be added to your monthly invoice at the beginning of the next month.",
    "billing-balance-top-up-actions-pay-label": "pay",
    "billing-balance-top-up-actions-cancel-label": "cancel",

    "billing-meters-title": "meters",
    "billing-meters-loading": "loading...",
    "billing-meters-no-meters": "no meters",
    "billing-meters-table-col-product": "product",
    "billing-meters-table-col-price": "price",
    "billing-meters-table-col-free-quota": "used quota",
    "billing-meters-table-col-operations": "operations",
    "billing-meters-table-col-free-quota-period": "per",
    "billing-meters-table-col-free-quota-period-day": "day",
    "billing-meters-table-col-free-quota-period-week": "week",
    "billing-meters-table-col-free-quota-period-month": "month",
    "billing-meters-table-col-free-quota-period-year": "year",
    "billing-meters-table-col-free-quota-resets": "resets",
    "billing-meters-table-col-billable": "billable",
    "billing-meters-table-col-non-billable": "non-billable",

    "billing-operation-estimate-title": "fee",
    "billing-operation-estimate-form-field-operation-name-label": "operation",
    "billing-operation-estimate-form-field-operation-fee-label": "fee",
    "billing-operation-estimate-form-field-operation-fee-free-label": "free",
    "billing-operation-estimate-form-field-operation-fee-per-unit-label": "fee per unit",
    "billing-operation-estimate-form-field-operation-fee-total-label": "fee total",
    "billing-operation-estimate-form-field-operation-balance-label": "balance",
    "billing-operation-estimate-form-field-operation-balance-top-up-button-label": "top-up",
    "billing-operation-estimate-form-field-operation-free-quota-left-label": "free quota left",

    "entitlement-entitlements-table-col-code": "code",
    "entitlement-entitlements-table-col-type": "type",
    "entitlement-entitlements-table-col-status": "status",

    "entitlement-entitlements-table-col-balance": "balance",
    "entitlement-entitlements-table-col-balance-status": "balance status",
    "entitlement-entitlements-table-col-available-status": "available status",
    "entitlement-entitlements-table-col-available": "available",
    "entitlement-entitlements-table-col-currency": "CCY",
    "entitlement-entitlements-table-col-person": "person",
    "entitlement-entitlements-table-col-validFrom": "valid from",
    "entitlement-entitlements-table-col-validTo": "valid to",
    "entitlement-entitlements-table-col-lastUsedAt": "last used at",
    "entitlement-entitlements-table-col-lastDebitedAt": "last debited at",
    "entitlement-entitlements-table-col-createdAt": "entitlement created at",
    "entitlement-entitlements-table-col-balance-createdAt": "balance created at",
    "entitlement-entitlements-col-value-status-unused": "unused",
    "entitlement-entitlements-col-value-status-linked": "linked",
    "entitlement-entitlements-col-value-status-unlinked": "unlinked",
    "entitlement-entitlements-col-value-status-suspended": "suspended",
    "entitlement-entitlements-col-value-status-voided": "voided",
    "entitlement-entitlements-col-value-balance-status-inactive": "inactive",
    "entitlement-entitlements-col-value-balance-status-active": "active",
    "entitlement-entitlements-col-value-balance-status-locked": "locked",
    "entitlement-entitlements-col-value-balance-status-suspended": "suspended",
    "entitlement-entitlements-col-value-balance-status-expired": "expired",
    "entitlement-entitlements-col-value-balance-status-closed": "closed",
    "entitlement-entitlements-col-value-available-status-full": "full",
    "entitlement-entitlements-col-value-available-status-used": "used",
    "entitlement-entitlements-col-value-available-status-depleted": "depleted",
    "entitlement-entitlements-type-card": "card",
    "entitlement-entitlements-type-pass": "pass",
    "entitlement-entitlements-type-voucher": "voucher",

    "entitlement-entitlements-detail-type-label": "type",
    "entitlement-entitlements-detail-status-label": "status",
    "entitlement-entitlements-detail-balance-name-untitled": "untitled",
    "entitlement-entitlements-detail-balance-label": "balance",
    "entitlement-entitlements-detail-balance-unlink-label": "unlink",
    "entitlement-entitlements-detail-balance-unlink-label-confirm": "confirm",
    "entitlement-entitlements-detail-balance-link-label": "link",
    "entitlement-entitlements-detail-person-label": "person",
    "entitlement-entitlements-detail-order-label": "order",
    "entitlement-entitlements-detail-pdf-label": "PDF",
    "entitlement-entitlements-detail-pdf-button-download-label": "download",
    "entitlement-entitlements-detail-history-label": "history",
    "entitlement-entitlements-detail-status-unused": "unused",
    "entitlement-entitlements-detail-status-linked": "linked",
    "entitlement-entitlements-detail-status-unlinked": "unlinked",
    "entitlement-entitlements-detail-status-suspended": "suspended",
    "entitlement-entitlements-detail-status-voided": "voided",
    "entitlement-entitlements-detail-link-balance-form-title": "link balance",
    "entitlement-entitlements-detail-history-action-balance-link": "balance linked",
    "entitlement-entitlements-detail-history-action-balance-unlink": "balance unlinked",
    "entitlement-entitlements-detail-history-action-card-create": "card created",
    "entitlement-entitlements-detail-history-action-card-link": "card linked",
    "entitlement-entitlements-detail-history-action-card-unlink": "card unlinked",
    "entitlement-entitlements-detail-history-action-card-transfer": "card transferred",
    "entitlement-entitlements-detail-history-action-card-void": "card voided",

    // entitlement: voucher templates
    "entitlement-voucher-templates-add-form-title": "create voucher template",
    "entitlement-voucher-templates-table-col-label-name": "name",
    "entitlement-voucher-templates-table-col-label-locale": "locale",
    "entitlement-voucher-templates-table-col-label-created": "created",
    "entitlement-voucher-templates-add-form-name-label": "name",
    "entitlement-voucher-templates-add-form-name-placeholder": "business partner Company LLC",
    "entitlement-voucher-templates-add-form-image-label": "image",
    "entitlement-voucher-templates-add-form-message-label": "message",
    "entitlement-voucher-templates-add-form-message-placeholder": "happy holidays",
    "entitlement-voucher-templates-add-form-message-caption":
      "message to be displayed on the voucher. use [BR] for line breaks.",
    "entitlement-voucher-templates-add-form-title-label": "title",
    "entitlement-voucher-templates-add-form-title-placeholder": "gift voucher",
    "entitlement-voucher-templates-add-form-subtitle-label": "subtitle",
    "entitlement-voucher-templates-add-form-subtitle-placeholder": "for our services",
    "entitlement-voucher-templates-add-form-product-name-label": "product name",
    "entitlement-voucher-templates-add-form-product-name-placeholder": "spa treatment",
    "entitlement-voucher-templates-add-form-product-name-caption":
      "use [PRICE] to display the price of the product.",
    "entitlement-voucher-templates-add-form-product-description-label": "product description",
    "entitlement-voucher-templates-add-form-product-description-placeholder":
      "relaxing massage and wellness package",
    "entitlement-voucher-templates-add-form-product-description-caption":
      "use [PRICE] to display the price of the product.",
    "entitlement-voucher-templates-add-form-footer-line-1-label": "footer line 1",
    "entitlement-voucher-templates-add-form-footer-line-1-placeholder": "example.com",
    "entitlement-voucher-templates-add-form-footer-line-2-label": "footer line 2",
    "entitlement-voucher-templates-add-form-footer-line-2-placeholder": "example.com",
    "entitlement-voucher-templates-add-form-footer-line-caption":
      "The template cannot be edited after saving.",
    "entitlement-voucher-templates-add-form-save-label": "save",
    "entitlement-voucher-templates-add-form-preview-label": "preview",
    "entitlement-voucher-templates-add-form-cancel-label": "cancel",
    "entitlement-voucher-templates-add-form-cancel-label-secondary": "confirm",
    "address-street": "Street",
    "address-number": "Building Number",
    "address-area": "Area",
    "address-city": "City",
    "address-zip": "ZIP code",
    "address-region": "Region",
    "address-country": "Country",
    "commerce-invoice-disclaimer": "Invoice disclaimer",

    // if you change this, change the client translation file
    "cart-main-title": "Cart",
    "cart-header-backToShop": "Continue shoppping",
    "cart-itemList-empty": "Nothing here. 😔 Pick something 🙃",
    "cart-promoCode-title": "Promo code",
    "cart-promoCode-insert": "Use promo code",
    "cart-promoCode-field-promoCode-label": "Do you have a promo code?",
    "cart-promoCode-field-promoCode-placeholder":
      "Magic key, that makes you save while spending. 😜",
    "cart-promoCode-field-promoCode-helpText": "ABRACADABRA",
    "cart-delivery-title": "Delivery",
    "cart-delivery-branch-title": "Branch",
    "cart-delivery-undeliverableItemsCombination":
      "This product combination can't be delivered. Please order separately.",
    "cart-delivery-deliveryOptions": "Delivery options",
    "cart-customerInfo-title": "My info",
    "cart-customerInfo-actionButtons-addBillingInfo": "Enter billing info",
    "cart-customerInfo-fields-customerEmail-label": "E-mail",
    "cart-customerInfo-fields-customerEmail-placeholder": "john@smith.com",
    "cart-customerInfo-fields-customerEmail-helpText":
      "We need your e-mail to inform you about your order state.",
    "cart-customerInfo-fields-customerName-label": "Name and surname",
    "cart-customerInfo-fields-customerName-placeholder": "John Smith",
    "cart-customerInfo-fields-customerName-helpText": "",
    "cart-customerInfo-fields-customerPhone-label": "Phone",
    "cart-customerInfo-fields-customerPhone-placeholder": "123 456 789",
    "cart-customerInfo-fields-customerPhone-helpText":
      "We need your phone in order to contact you promply in case of an unexpected event.",
    "cart-billingInfo-title": "Invoicing",
    "cart-billingInfo-actionButtons-fillManually": "Fill manually",
    "cart-billingInfo-actionButtons-companyAddress": "Invoice company",
    "cart-billingInfo-fields-billingAddress-label": "Address",
    "cart-billingInfo-fields-billingAddress-placeholder": "Main st. 1, Prague",
    "cart-billingInfo-fields-billingAddress-helpText": "",
    "cart-billingInfo-fields-billingAddressStreet-label": "Street",
    "cart-billingInfo-fields-billingAddressStreet-placeholder": "Main st. 1, Prague",
    "cart-billingInfo-fields-billingAddressStreet-helpText": "",
    "cart-billingInfo-fields-billingAddressCity-label": "City",
    "cart-billingInfo-fields-billingAddressCity-placeholder": "Prague",
    "cart-billingInfo-fields-billingAddressCity-helpText": "",
    "cart-billingInfo-fields-billingAddressPostal-label": "Postal",
    "cart-billingInfo-fields-billingAddressPostal-placeholder": "110 00",
    "cart-billingInfo-fields-billingAddressPostal-helpText": "",
    "cart-billingInfo-fields-billingAddressCompanyICO-label": "Reg. no.",
    "cart-billingInfo-fields-billingAddressCompanyICO-placeholder": "123 45 678",
    "cart-billingInfo-fields-billingAddressCompanyICO-helpText": "",
    "cart-billingInfo-fields-billingAddressCompanyName-label": "Company",
    "cart-billingInfo-fields-billingAddressCompanyName-placeholder": "Company s.r.o.",
    "cart-billingInfo-fields-billingAddressCompanyName-helpText": "",
    "cart-billingInfo-fields-invoiceNote-label": "Invoice note",
    "cart-billingInfo-fields-invoiceNote-placeholder": "Gift for the boss",
    "cart-billingInfo-fields-invoiceNote-helpText": "",
    "cart-deliveryInfo-title": "Delivery",
    "cart-deliveryInfo-actionButtons-fillManually": "Fill manually",
    "cart-deliveryInfo-actionButtons-companyAddress": "Deliver to a business",
    "cart-deliveryInfo-actionButtons-otherBillingInfo": "Other billing info",
    "cart-deliveryInfo-actionButtons-addBillingInfo": "Add billing info",
    "cart-deliveryInfo-recipientSameAsCustomerOptions-true": "for me",
    "cart-deliveryInfo-recipientSameAsCustomerOptions-false": "as a gift",
    "cart-deliveryInfo-fields-recipientName-label": "Name and surname",
    "cart-deliveryInfo-fields-recipientName-placeholder": "John Smith",
    "cart-deliveryInfo-fields-recipientName-helpText": "",
    "cart-deliveryInfo-fields-recipientPhone-label": "Phone",
    "cart-deliveryInfo-fields-recipientPhone-placeholder": "123 456 789",
    "cart-deliveryInfo-fields-recipientPhone-helpText": "We need a phone for the delivery courier.",
    "cart-deliveryInfo-fields-deliveryAddress-label": "Adresa",
    "cart-deliveryInfo-fields-deliveryAddress-placeholder": "Main st. 1, Prague",
    "cart-deliveryInfo-fields-deliveryAddress-helpText": "",
    "cart-deliveryInfo-fields-deliveryAddressStreet-label": "Street",
    "cart-deliveryInfo-fields-deliveryAddressStreet-placeholder": "Main st. 1, Prague",
    "cart-deliveryInfo-fields-deliveryAddressStreet-helpText": "",
    "cart-deliveryInfo-fields-deliveryAddressCity-label": "City",
    "cart-deliveryInfo-fields-deliveryAddressCity-placeholder": "Prague",
    "cart-deliveryInfo-fields-deliveryAddressCity-helpText": "",
    "cart-deliveryInfo-fields-deliveryAddressPostal-label": "Postal",
    "cart-deliveryInfo-fields-deliveryAddressPostal-placeholder": "110 00",
    "cart-deliveryInfo-fields-deliveryAddressPostal-helpText": "",
    "cart-deliveryInfo-fields-deliveryAddressCompanyICO-label": "Reg. no.",
    "cart-deliveryInfo-fields-deliveryAddressCompanyICO-placeholder": "123 456 789",
    "cart-deliveryInfo-fields-deliveryAddressCompanyICO-helpText": "",
    "cart-deliveryInfo-fields-deliveryAddressCompanyName-label": "Company",
    "cart-deliveryInfo-fields-deliveryAddressCompanyName-placeholder": "Company s.r.o.",
    "cart-deliveryInfo-fields-deliveryAddressCompanyName-helpText": "",
    "cart-deliveryInfo-fields-deliveryNote-label": "Delivery note",
    "cart-deliveryInfo-fields-deliveryNote-placeholder": "",
    "cart-deliveryInfo-fields-deliveryNote-helpText": "",
    "cart-deliveryInfo-fields-recipientNote-label": "Recipient note",
    "cart-deliveryInfo-fields-recipientNote-placeholder": "",
    "cart-deliveryInfo-fields-recipientNote-helpText": "",
    "cart-deliveryInfo-fields-recipientInQuarantine-labelTrue": "Contactless delivery",
    "cart-deliverySlots-noMoreDaysAvailable": "no other days<br>planned yet 😔",
    "cart-deliverySlots-noMoreSlotsAvailable": "No more free<br>slots available 😔",
    "cart-note-title": "Note",
    "cart-note-insert": "Add note",
    "cart-note-fields-note-label": "Anything else on your mind?",
    "cart-note-fields-note-placeholder": "Load!",
    "cart-note-fields-note-helpText":
      "We will try to give you the moon! We're still people, though 😜",
    "cart-payment-title": "Payment",
    "cart-stripeWallet-otherMethod": "Other method",
    "cart-orderButton-terms-pre": "By payment I agree to",
    "cart-orderButton-terms-link": "terms",
    "cart-confirmation-orderNumber-heading": "order",
    "cart-confirmation-email-heading": "confirmation",
    "cart-confirmation-merchantNote": "Looking forward to next time!",
    "cart-confirmation-continueShoppingBtn": "something else? 😜",

    // confirmation texts - these are configured in delivery methods
    "cart-confirmation-method-recipientSameAsCustomer-title": "Thank you",
    "cart-confirmation-method-recipientSameAsCustomer-paragraph": "Your order is being processed.",
    "cart-confirmation-method-recipientNotSameAsCustomer-title": "Thank you",
    "cart-confirmation-method-recipientNotSameAsCustomer-paragraph":
      "Your order is being processed and soon will be dispatched to the recipient.",

    // labels for override form
    "override-section--postfix-label": "label",
    "override-section--postfix-placeholder": "placeholder",
    "override-section--postfix-helpText": "help",
    "override-section-cart-main": "main",
    "override-section-cart-main-key-cart-main-title": "cart title",
    "override-section-cart-header": "header",
    "override-section-cart-header-key-cart-header-backToShop": "close cart button",
    "override-section-cart-itemList": "items",
    "override-section-cart-itemList-key-cart-itemList-empty": "empty cart",
    "override-section-cart-promoCode": "promo code",
    "override-section-cart-promoCode-key-cart-promoCode-title": "promo code title",
    "override-section-cart-promoCode-key-cart-promoCode-field-promoCode": "promo code",
    "override-section-cart-delivery": "delivery",
    "override-section-cart-delivery-key-cart-delivery-title": "delivery title",
    "override-section-cart-delivery-key-cart-delivery-branch-title": "branch title",
    "override-section-cart-delivery-key-cart-delivery-undeliverableItemsCombination":
      "undeliveable items combination text",
    "override-section-cart-delivery-key-cart-delivery-deliveryOptions": "delivery options title",
    "override-section-cart-customerInfo": "customer",
    "override-section-cart-customerInfo-key-cart-customerInfo-title": "customer title",
    "override-section-cart-customerInfo-key-cart-customerInfo-actionButtons-addBillingInfo":
      "add billing info button",
    "override-section-cart-customerInfo-key-cart-customerInfo-fields-customerEmail": "e-mail",
    "override-section-cart-customerInfo-key-cart-customerInfo-fields-customerName": "name",
    "override-section-cart-customerInfo-key-cart-customerInfo-fields-customerPhone": "phone",
    "override-section-cart-billingInfo": "billing info",
    "override-section-cart-billingInfo-key-cart-billingInfo-title": "billing info title",
    "override-section-cart-billingInfo-key-cart-billingInfo-actionButtons-fillManually":
      "fill manually button",
    "override-section-cart-billingInfo-key-cart-billingInfo-actionButtons-companyAddress":
      "company address button",
    "override-section-cart-billingInfo-key-cart-billingInfo-fields-billingAddress": "address",
    "override-section-cart-billingInfo-key-cart-billingInfo-fields-billingAddressStreet": "street",
    "override-section-cart-billingInfo-key-cart-billingInfo-fields-billingAddressCity": "city",
    "override-section-cart-billingInfo-key-cart-billingInfo-fields-billingAddressPostal": "postal",
    "override-section-cart-billingInfo-key-cart-billingInfo-fields-billingAddressCompanyICO":
      "Reg. no.",
    "override-section-cart-billingInfo-key-cart-billingInfo-fields-billingAddressCompanyName":
      "Company",
    "override-section-cart-billingInfo-key-cart-billingInfo-fields-invoiceNote": "invoice note",
    "override-section-cart-deliveryInfo": "delivery info",
    "override-section-cart-deliveryInfo-key-cart-deliveryInfo-title": "delivery info title",
    "override-section-cart-deliveryInfo-key-cart-deliveryInfo-actionButtons-fillManually":
      "fill manually button",
    "override-section-cart-deliveryInfo-key-cart-deliveryInfo-actionButtons-companyAddress":
      "company address button",
    "override-section-cart-deliveryInfo-key-cart-deliveryInfo-actionButtons-otherBillingInfo":
      "other billing info button",
    "override-section-cart-deliveryInfo-key-cart-deliveryInfo-actionButtons-addBillingInfo":
      "add billing info button",
    "override-section-cart-deliveryInfo-key-cart-deliveryInfo-recipientSameAsCustomerOptions-true":
      "recipient is same as buyer",
    "override-section-cart-deliveryInfo-key-cart-deliveryInfo-recipientSameAsCustomerOptions-false":
      "recipient is different from buyer",
    "override-section-cart-deliveryInfo-key-cart-deliveryInfo-fields-recipientName": "name",
    "override-section-cart-deliveryInfo-key-cart-deliveryInfo-fields-recipientPhone": "phone",
    "override-section-cart-deliveryInfo-key-cart-deliveryInfo-fields-deliveryAddress": "address",
    "override-section-cart-deliveryInfo-key-cart-deliveryInfo-fields-deliveryAddressStreet":
      "street",
    "override-section-cart-deliveryInfo-key-cart-deliveryInfo-fields-deliveryAddressCity": "city",
    "override-section-cart-deliveryInfo-key-cart-deliveryInfo-fields-deliveryAddressPostal":
      "postal",
    "override-section-cart-deliveryInfo-key-cart-deliveryInfo-fields-deliveryAddressCompanyICO":
      "reg. no.",
    "override-section-cart-deliveryInfo-key-cart-deliveryInfo-fields-deliveryAddressCompanyName":
      "company",
    "override-section-cart-deliveryInfo-key-cart-deliveryInfo-fields-deliveryNote": "delivery note",
    "override-section-cart-deliveryInfo-key-cart-deliveryInfo-fields-recipientNote":
      "recipient note",
    "override-section-cart-deliveryInfo-key-cart-deliveryInfo-fields-recipientInQuarantine-labelTrue":
      "recipient in quarantine",
    "override-section-cart-deliverySlots": "delivery slots",
    "override-section-cart-deliverySlots-key-cart-deliverySlots-noMoreDaysAvailable":
      "no more days available",
    "override-section-cart-deliverySlots-key-cart-deliverySlots-noMoreSlotsAvailable":
      "no more slots available",
    "override-section-cart-note": "note",
    "override-section-cart-note-key-cart-note-title": "note title",
    "override-section-cart-note-key-cart-note-fields-note": "note",
    "override-section-cart-payment": "payment",
    "override-section-cart-payment-key-cart-payment-title": "payment title",
    "override-section-cart-confirmation": "confirmation",
    "override-section-cart-confirmation-key-cart-confirmation-orderNumber-heading":
      "order number heading",
    "override-section-cart-confirmation-key-cart-confirmation-email-heading": "e-mail heading",
    "override-section-cart-confirmation-key-cart-confirmation-merchantNote": "merchant note",
    "override-section-cart-confirmation-key-cart-confirmation-continueShoppingBtn":
      "continue shopping button",
    "override-section-cart-orderButton": "order",
    "override-section-cart-orderButton-key-cart-orderButton-terms-pre": "terms - perex",
    "override-section-cart-orderButton-key-cart-orderButton-terms-link": "terms - link",

    "product-field-title": "Title",
    "product-field-description": "Description",
    "product-field-google-product-category": "Product Category ID",
    "product-tags": "Tags",
    "product-sku": "SKU",
    "product-options": "Options",
    "product-variants": "Variants",
    "product-dynamic-sections": "Dynamic sections",
    "product-customer-form": "Customer form",
    "product-kind": "Kind",
    "product-sub-kind": "Subkind",
    "product-images": "Images",
    "product-gift-card-images": "Images for gift card",
    "product-gift-card-images-description":
      "JPEG format; Keep the image aspect ratio approximately 1:2. For upload, we recommend min. resolution of 1 170 x 2 480 px; other dimensions will be automatically centered and cropped when generating the PDF. The final printed size is DL format (1/3 A4 = 99 x 210 mm).",
    "product-gift-card-settings": "Gift Card settings",
    "product-booking-settings": "Booking settings",
    "product-quantity": "Stock & visibility",
    "product-quantity-stock": "Stock",
    "product-quantity-available": "available",
    "product-quantity-blocked": "blocked",
    "product-quantity-reserved": "reserved",
    "product-quantity-when-sold-out": "when sold out",
    "product-shipping": "Shipping",
    "product-shipping-dimensions": "Dimensions",
    "product-shipping-available-deliveries": "Available delivery",
    "product-channels": "Channels",
    "item-labels": "attributes",
    "item-labels-adding-name": "name",
    "item-labels-group": "attributes group",
    "item-labels-add": "add attribute",
    "item-vod-videos": "videos on demand",
    "item-vod-free-preview": "free preview",
    "item-vod-seconds": "seconds",
    "item-vod-or": "or",
    "item-vod-separate-video": "add separate video",
    "item-vod-remove": "remove",
    "item-vod-confirm": "confirm",
    "item-vod-processing": "processing",
    "item-vod-notified-via-email": "When processing is done, you will be notified via e-mail.",
    "system-settings": "System settings",
    "other-settings": "Other",
    "channel-online": "Online",
    "product-files": "Files",
    "add-a-new": "Add another:",
    "button-add-variant": "Add variant",
    "button-add-product": "Product",
    "button-add-option": "+ Add option",
    "button-add-attribute": "+ Add atrribute",
    "product-field-type": "Type",
    "product-field-name": "Name",
    "question-product-opt-delete": "Do you really want to delete this option?",
    "question-product-product-delete": "Do you really want to delete this product?",
    "question-product-product-variants-delete":
      "Do you really want to delete this product and its variants?",
    "product-enable-stock-track": "track stock",
    "product-min-order": "Minimal order amount:",
    "product-when-sold-out": "When sold out:",
    "product-on-sold-hide": "hide",
    "product-on-sold-disable": "restrict",
    "product-on-sold-preorder": "preorder",
    "product-show-as-preorder": "preorder",
    "product-show-as": "Visibility",
    "product-show-as-hide": "hidden",
    "product-show-as-unavailable": "unavailable",
    "product-show-as-available": "available",
    "product-show-as-auto": "by stock",
    "product-show-stock-counts": "Show stock counts",
    "product-pricing": "Pricing",
    "product-enable-reservation": "Allow reservation",
    "product-reservation-timeout": "Time to keep product in cart for order",
    "commerce-pricing-base": "Base",
    "commerce-pricing-tax": "Tax",
    "commerce-pricing-final": "Final",
    "commerce-pricing-purchased": "Purchased",
    "commerce-pricing-commission": "Commission",
    "commerce-pricing-profit": "Profit",
    "commerce-package-dimensions-length": "l",
    "commerce-package-dimensions-width": "w",
    "commerce-package-dimensions-height": "h",
    "shipping-weight": "Weight [kg]",
    "shipping-dimensions": "Dimensions [cm]",
    "question-product-file-attr-delete": "Do you really want to delete this attribute?",
    "question-product-file-delete": "Do you really want to delete this file?",

    "signup-email": "What is your email?",
    "signup-site-domain": "What will be your site domain?",
    "signup-done": "... check your email inbox.",

    "products-prepared": "Ready -> Sent",

    "button-cancel": "Cancel",
    "button-confirm": "Confirm",
    "button-remove": "Remove",
    "button-save-draft": "Save draft",
    "button-publish": "Publish",
    "button-publish-all": "Publish all",
    "button-save": "Save",
    "button-add": "Add",
    "button-add-file": "Add file",
    "button-change-file": "Change file",
    "button-add-font": "Add font",
    "button-delete": "Delete",
    "button-all": "All",
    "button-signup": "Signup",

    "order-incomming-new": "New order!",
    // "order-incomming-new" : "New order! [%0]",
    "orders-customer": "Customer",
    "orders-products": "Products",
    "orders-shipping": "Shipping",
    "order-payment-not-paid": "Not paid yet",
    "order-payment-paid": "Paid at:",
    "order-customer-note": "Customer note",
    "order-customer-notify": "Notify customer",
    "order-note-add": "Add note",
    "order-pay-products": "Products",
    "order-pay-delivery": "Shipping",
    "order-pay-payment": "Payment",
    "order-pay-discount": "Discount",
    "order-pay-total": "Customer pays",
    "order-pay-method-card-online": "Card online",
    "order-pay-method-card-site": "Card in a shop",
    "order-pay-method-card-deliv": "Card at the delivery",
    "order-pay-method-cash-site": "Cash in a shop",
    "order-pay-method-cash-deliv": "Cash at the delivery",
    "order-pay-method-bank-wire": "bank wire",
    "order-pay-method-paypal": "Paypal",
    "order-shipping-method-branch": "Branch pickup",
    "order-shipping-method-branch-pob1-onspot": "Branch pickup",
    "order-shipping-method-messanger": "Kurýr",
    "order-shipping-method-ppl": "PPL",
    "order-shipping-method-ups": "UPS",
    "order-shipping-method-zasilkovna": "Zásilkovna",
    "order-shipping-method-cpost": "Czech post",
    "order-shipping-method-cpost-ob": "Czech post - business package",
    "order-shipping-method-custom": "Custom",
    "order-shipping-method-popup": "Pop-up",
    "order-shipping-method-popup-praktika1": "Pop-up Praktika Letná",
    "order-shipping-method-no-delivery": "No delivery",
    "order-details-title": "Order details",
    "order-details-created": "created",
    "order-details-paid": "paid",
    "order-details-due": "due",
    "order-details-tax": "tax",
    "order-details-variable-symbol": "variable symbol",

    oa_state_unpaid: "Unpaid",
    oa_state_paid: "Paid",
    oa_state_preparing: "Preparing products",
    oa_state_printing: "Printing labels",
    oa_state_packing: "Packing",
    oa_state_dispatching: "Dispatching",
    oa_state_sent: "Sent",
    oa_state_pickup: "Forpickup",
    oa_state_refunding: "Refunding",
    oa_state_cancelled: "Cancelled",
    oa_state_archived: "Archived",
    oa_go_paid: "Was paid",
    oa_go_prepare: "Prepare products",
    oa_go_print: "Print Label",
    oa_go_pack: "Pack goods",
    oa_go_cancel: "Cancel",
    oa_go_dispatch: "Dispatch",
    oa_go_send: "Send",
    oa_go_pickup: "Ready to pickup",
    oa_go_refund: "Refund",
    oa_go_archive: "Archive",
    oa_go_open: "Open",

    "user-action-user-looked": "Order opened",
    "user-action-moving-state": "State changed",
    "user-action-info-note-checked": "Customer note checked",
    "user-action-info-note-unchecked": "Customer note unchecked",
    "user-action-courier-note-checked": "Courier note checked",
    "user-action-courier-note-unchecked": "Courier note unchecked",
    "user-action-recipient-note-checked": "Recipient note checked",
    "user-action-recipient-note-unchecked": "Recipient note unchecked",
    "user-action-contactless-checked": "Contactless delivery checked",
    "user-action-contactless-unchecked": "Contactless delivery unchecked",
    "user-action-item-checked": "Item checked",
    "user-action-item-unchecked": "Item unchecked",
    "user-action-updated-private-note": "Private note updated",
    "user-action-deleted-private-note": "Private note deleted",
    "user-action-invoice-downloaded": "Invoice downloaded",
    "user-action-invoice-sent": "Invoice manually sent to customer",
    "user-action-email-sent": "Email sent",
    "user-action-refundSlip-downloaded": "Refund slip downloaded",
    "cart-created": "Cart created",
    "cart-item-added": "Item added",
    "cart-item-updated": "Item updated",
    "cart-item-removed": "Item removed",
    "order-created": "Order created",
    "stripe-payment-created": "Payment started",
    "stripe-payment-requires-action": "Payment requires action",
    "stripe-payment-succeeded": "Payment succeeded",
    "stripe-payment-failed": "Payment failed",
    "resend-sent": "E-mail sent",
    "resend-delivery_delayed": "E-mail delayed",
    "resend-bounced": "E-mail bounced",
    "resend-delivered": "E-mail delivered",
    "resend-opened": "E-mail opened",
    "resend-clicked": "Link in e-mail opened",
    "resend-complained": "E-mail reported as spam",
    "sendgrid-processed": "E-mail processed",
    "sendgrid-deferred": "E-mail deferred",
    "sendgrid-delivered": "E-mail delivered",
    "sendgrid-open": "E-mail opened",
    "sendgrid-click": "Link in e-mail opened",
    "sendgrid-bounce": "E-mail bounced",
    "sendgrid-dropped": "E-mail dropped",
    "sendgrid-blocked": "E-mail blocked",
    "sendgrid-spamreport": "E-mail marked as spam",
    "sendNotification-sent": "E-mail sent",
    "sendNotification-error": "E-mail not sent",
    "invoice-download": "invoice download by customer",
    "digital-product-download": "digital product download by customer",
    "giftCard-download-by-customer": "gift card download by customer",
    "giftCard-download-by-recipient": "gift card download by recipient",

    "stripe-error-card-expired": "Card expired. Please use another card.",
    "stripe-decline-card-expired": "Card expired. Please use another card.",
    "stripe-decline-auth-required": "Payment needs authorization. Please try again.",
    "stripe-decline-try-again": "Please try again or contact your bank.",
    "stripe-decline-contact-bank": "Please contact your bank.",
    "stripe-decline-duplicate": "Duplicate payment.",
    "stripe-decline-incorrect-number": "Incorrect card number",
    "stripe-decline-incorrect-cvc": "Incorrect CVC",
    "stripe-decline-incorrect-expiry": "Incorrect expiry",
    "stripe-decline-insufficient-funds": "Please check your account balance.",
    "stripe-decline-test-card": "Do not use test card.",
    "stripe-decline-test-mode-live-card": "Live card used in test mode",

    "stripe-requires-action-3ds2": "3D secure verification",

    "billing-address": "Billing address",
    "delivery-address": "Delivery details",

    "block-config-name": "Block name",
    "block-config-tag": "Tag",
    "block-config-shared": "Shared",
    "block-config-region": "Region",
    "block-config-viewports": "Viewports",

    "forms-field-id": "ID",
    "forms-field-type": "Field type",
    "target-window-same": "Same window",
    "target-window-new": "New window",

    "form-font-name": "Font name",
    "form-font-weight": "Font weight",
    "form-font-url": "Font URL",
    "form-font-source-file": "Font file",

    "page-create-new": "New page",
    "page-create-new-abort": "Abort adding new page",
    "page-create-new-info": "Now select parental page of the new one",
    "page-new-name": "New page",
    "page-new-slug": "newpage",
    "page-new-created": "New page created",
    "page-new-not-created": "The page was not created.",
    "shared-blocks-label": "Shared",
    "private-blocks-label": "Private",

    "settings-css-header": "Styles",
    "settings-scripts-header": "Scripts",
    "settings-config-header": "Styles config",
    "settings-fonts-header": "Fonts",

    "template-editor": "Templates",
    "theme-label-fonts": "Fonts",
    "theme-label-scripts": "Script files",

    "field-listing-source": "Source",
    "field-listing-root-page": "Root page",

    "question-publish-all": "Do you relly want to publish all?",
    "message-info-site-published": "Site has been published.",
    "error-login-nonce-request":
      "Login failed. Please, repeat the process one more time, and in case it didn't work either, please do not hesitate to contact us.",
    "error-email-invlaid": "E-mail address is not valid!",
    "error-email-not-found": "E-mail address was not found!",
    "error-sitemName-already-used": "This site name is already used!",
    "error-email-already-used": "This E-mail address is already used!",
    "error-both-already-used": "Both values are already used!",
    "error-invlaid-values": "The form is not filled properly!",

    // Profile
    "profile-change-password": "Change password",
    "profile-passkeys": "Passkeys",
    "profile-notifications": "Notifikace",
    "profile-admin-lang": "Admin language",

    // View titles
    "view-title-apps": "apps",
    "view-title-sites": "sites",
    "view-title-site-settings": "site settings",
    "view-title-site-settings-sections": "sections",
    "view-title-site-settings-domains": "domains",
    "view-title-pages": "pages",
    "view-title-page-settings": "page settings",
    "view-title-documents": "documents",
    "view-title-documents-wizard": "wizard",
    "view-title-documents-layouts": "layouts",
    "view-title-documents-layout-edit": "edit layout",
    "view-title-documents-templates": "templates",
    "view-title-documents-generated": "generated",
    "documents-generated-table-col-name": "name",
    "documents-generated-table-col-template": "template",
    "documents-generated-table-col-layout": "layout",
    "documents-generated-table-col-total-documents": "total documents",
    "documents-generated-table-col-output-format": "output format",
    "documents-generated-table-col-status": "status",
    "documents-generated-table-col-created": "created",
    "documents-generated-table-col-actions": "actions",
    "documents-generated-download": "download",
    "documents-generated-regenerate": "regenerate",
    "documents-generated-selected": "selected",
    "documents-generated-output-format-zip": "ZIP (PDF per page)",
    "documents-generated-output-format-single": "single PDF",
    "documents-generated-error-loading": "error loading document generations",
    "documents-generated-download-unavailable": "download unavailable",
    "documents-generated-download-unavailable-no-url": "no download URL available for this document",
    "documents-generated-download-unavailable-no-documents": "no documents found for this generation",
    "documents-generated-error-downloading": "error downloading document",
    "documents-generated-download-failed": "download failed",
    "documents-generated-download-failed-message": "failed to download file",
    "documents-generated-no-items-selected": "no items selected",
    "documents-generated-no-items-selected-message": "please select at least one generation to regenerate",
    "documents-generated-regeneration-successful": "regeneration successful",
    "documents-generated-regeneration-successful-message": "%0 generations regenerated",
    "documents-generated-regeneration-completed-with-errors": "regeneration completed with errors",
    "documents-generated-regeneration-completed-with-errors-message": "%0 successful, %1 failed",
    "documents-generated-status-pending": "pending",
    "documents-generated-status-processing": "processing",
    "documents-generated-status-completed": "completed",
    "documents-generated-status-failed": "failed",
    "documents-generated-status-cancelled": "cancelled",
    "view-title-documents-wizard-option-simplest-title": "choose existing layout",
    "view-title-documents-wizard-option-simplest-description":
      "i need stickers, vouchers and don't have print data or do not want to design it myself",
    "view-title-documents-wizard-option-simple-title": "use my print data",
    "view-title-documents-wizard-option-simple-description":
      "i have professional print data with crop marks and want to place codes on them",
    "view-title-documents-wizard-option-advanced-title": "design from scratch",
    "view-title-documents-wizard-option-advanced-description":
      "i want to create layout and template manually from scratch",
    "view-title-balances": "balances",
    "view-title-balances-detail": "balance",
    "view-title-balances-transact": "balance transaction",
    "view-title-identity-companies": "companies",
    "view-title-identity-persons": "persons",
    "view-title-booking": "booking",
    "view-title-booking-back": "back",
    "view-title-booking-reservations": "reservations",
    "view-title-booking-slots": "slots",
    "view-title-booking-services": "services",
    "view-title-booking-resources": "resources",
    "view-title-commerce": "commerce",
    "view-title-commerce-carts": "carts",
    "view-title-commerce-orders": "orders",
    "view-title-commerce-orders-items": "order items",
    "view-title-commerce-inventory": "inventory",
    "view-title-commerce-inventory-product": "product",
    "view-title-commerce-inventory-products": "products",
    "view-title-commerce-settings": "commerce settings",
    "view-title-commerce-order-flow": "order flow",
    "view-title-commerce-entitlements": "entitlements",
    "view-title-commerce-voucher-templates": "voucher templates",
    "view-title-commerce-promocodes": "promo codes",
    "view-title-commerce-giftcards": "gift cards",
    "view-title-commerce-giftcard-detail": "gift card",
    "view-title-commerce-giftcard-validation": "gift card validation",
    "view-title-commerce-delivery-planning": "delivery planning",
    "view-title-commerce-fee-reports": "fee reports",
    "view-title-billing": "billing",
    "view-title-billing-invoices": "invoices",
    "view-title-billing-balance": "balance",
    "view-title-billing-transactions": "transactions",
    "view-title-billing-meters": "meters",
    "view-title-profile": "my profile",
    "view-title-profile-changepassword": "password change",
    "view-title-profile-passkeys": "Passkeys",
    "view-title-profile-notifications": "Notifikace",
    "view-title-commerce-promocode-detail": "code detail",
    "view-title-commerce-promocode-import": "code import",
    "view-title-commerce-settings-general": "general",
    "view-title-commerce-settings-invoicing": "invoicing",
    "view-title-commerce-settings-payment": "payment",
    "view-title-commerce-settings-delivery": "delivery",
    "view-title-commerce-settings-delivery-method": "method",
    "view-title-commerce-settings-cart": "cart",
    "view-title-commerce-settings-emails": "emails",
    "view-title-commerce-settings-channels": "channels",
    "view-title-commerce-export": "export",
    "view-title-platform": "platform",
    "view-title-platform-wizard": "wizard",
    "view-title-platform-clients": "clients",
    "view-title-platform-clients-detail": "client",
    "view-title-platform-sites": "sites",
    "view-title-platform-sites-detail": "site",
    "view-title-platform-users": "users",
    "view-title-platform-users-detail": "user",
    "view-title-platform-billing-balances": "billing balances",
    "view-title-platform-shops": "shops",
    "view-title-platform-shops-detail": "shop",
    "view-title-platform-events": "events",
    "view-title-platform-events-detail": "event",
    "view-title-platform-api-keys": "api keys",
    "view-title-platform-api-scopes": "api scopes",
    "view-title-platform-entitlements-pass-projects": "ent. pass projects",
    "view-title-platform-entitlements-pass-apple-pki": "ent. pass apple pki",
    "view-title-platform-system": "system",
    "view-title-platform-orgs": "orgs",
    "view-title-tools": "tools",
    "view-title-tools-pos-emulator": "POS emulator",
    "view-title-tools-qr-generator": "QR generator",
    "view-title-tools-liftago-mock": "Liftago mock",
    "view-title-tools-qr-scanner": "QR scanner",
    "tools-qr-scanner-collection-label": "collection",
    "tools-qr-scanner-collection-create": "new",
    "tools-qr-scanner-collection-modal-title": "new collection",
    "tools-qr-scanner-collection-name-label": "name",
    "tools-qr-scanner-collection-cancel": "cancel",
    "tools-qr-scanner-collection-save": "create",
    "tools-qr-scanner-no-collection-hint": "select a collection to auto-save scans",
    "tools-qr-scanner-save-success": "code saved",
    "tools-qr-scanner-save-error": "save failed",
    "tools-qr-scanner-items-empty": "no scans yet",

    "delivery-method-constraints-label": "Delivery constraints",
    "delivery-method-constraints-min-dispatch-time": "Dispatched after",
    "delivery-method-constraints-min-dispatch-time-since-order": "since order",
    "delivery-method-constraints-shipping-from": "Dispatched from",
    "delivery-method-constraints-shipping-to": "Dispatched till",

    "platform-billing-balances-col-value-status-active": "active",
    "platform-billing-balances-col-value-status-suspended": "suspended",
    "platform-billing-balances-col-value-status-closed": "closed",
    "platform-billing-balances-table-col-id": "ID",
    "platform-billing-balances-table-col-org": "org",
    "platform-billing-balances-table-col-status": "status",
    "platform-billing-balances-table-col-available": "available",
    "platform-billing-balances-table-col-credit-limit": "credit limit",
    "platform-billing-balances-table-col-lifetime-credit": "lifetime credit",
    "platform-billing-balances-table-col-lifetime-debit": "lifetime debit",
    "platform-billing-balances-table-col-currency": "currency",
    "platform-billing-balances-table-col-created-at": "created at",
    "platform-billing-balances-table-col-updated-at": "updated at",
    "platform-billing-balances-button-transact-label": "transact",

    "platform-billing-balance-transact-form-title": "Transaction",
    "platform-billing-balance-transact-form-type-debit": "debit",
    "platform-billing-balance-transact-form-type-credit": "credit",
    "platform-billing-balance-transact-form-amount-label": "amount",
    "platform-billing-balance-transact-form-amount-placeholder": "1000",
    "platform-billing-balance-transact-form-actions-cancel-label": "cancel",
    "platform-billing-balance-transact-form-actions-transact-debit-label": "debit",
    "platform-billing-balance-transact-form-actions-transact-credit-label": "credit",
    "platform-billing-balance-transact-form-actions-transactConfirm-label": "confirm",
    "platform-billing-balance-transact-form-note-platform-label": "note",
    "platform-billing-balance-transact-form-note-platform-placeholder": "refund",
    "platform-billing-balance-transact-form-note-platform-caption": "internal",

    // entitlements add form
    "entitlements-add-form-title": "Create Entitlements",
    "entitlements-add-form-type": "Type",
    "entitlements-add-form-count": "Count",
    "entitlements-add-form-code": "Code",
    "entitlements-add-form-enter-code": "Enter code",
    "entitlements-add-form-codes": "Codes",
    "entitlements-add-form-one-code-per-line": "One code per line",
    "entitlements-add-form-enter-codes": "Enter codes",
    "entitlements-add-form-balance": "Balance",
    "entitlements-add-form-attach-to-existing-balance": "Attach to existing balance",
    "entitlements-add-form-balance-mode-none": "None",
    "entitlements-add-form-balance-mode-link": "Link to existing",
    "entitlements-add-form-balance-mode-create": "Create",
    "entitlements-add-form-code-mode-auto": "Auto",
    "entitlements-add-form-code-mode-auto-sublabel": "Codes are generated",
    "entitlements-add-form-code-mode-manual": "Manual",
    "entitlements-add-form-code-mode-manual-sublabel": "Enter codes",
    "entitlements-add-form-type-voucher-sublabel": "Digital / printed PDF or sticker",
    "entitlements-add-form-type-pass-sublabel": "Apple / Google Wallet pass",
    "entitlements-add-form-type-card-sublabel": "Physical card",
    "entitlements-add-form-template": "Template",
    "entitlements-add-form-generate-print-data": "Generate print data",
    "entitlements-add-form-print-data-name": "Name",
    "entitlements-add-form-print-data-name-default": "Bulk entitlement print data - %0 %1",
    "entitlements-add-form-print-data-name-default-item": "item",
    "entitlements-add-form-print-data-name-default-items": "items",
    "entitlements-add-form-print-data-format": "Print data format",
    "entitlements-add-form-print-data-format-single-pdf": "Multiple pages in one PDF",
    "entitlements-add-form-print-data-format-zip-pdfs": "PDF per page in ZIP",
    "entitlements-add-form-print-data-warning":
      "Generated files contain sensitive codes and must be handled cautiously. Ensure you're working with a trusted printing provider.",
    "entitlements-add-form-print-data-accept-risk": "I accept risk",
    "entitlements-add-form-link-person": "Link person",
    "entitlements-add-form-person": "Person",
    "entitlements-add-form-create": "Create",
    "entitlements-add-form-confirm": "Confirm",

    // document layout objects form
    "document-layout-objects-form-reference-point-top-left": "top left",
    "document-layout-objects-form-reference-point-top-center": "top center",
    "document-layout-objects-form-reference-point-top-right": "top right",
    "document-layout-objects-form-reference-point-middle-left": "middle left",
    "document-layout-objects-form-reference-point-center": "center",
    "document-layout-objects-form-reference-point-middle-right": "middle right",
    "document-layout-objects-form-reference-point-bottom-left": "bottom left",
    "document-layout-objects-form-reference-point-bottom-center": "bottom center",
    "document-layout-objects-form-reference-point-bottom-right": "bottom right",

    // document layouts table enum values
    "document-layouts-table-type-voucher": "voucher",
    "document-layouts-table-type-sticker": "sticker",
    "document-layouts-table-type-invoice": "invoice",
    "document-layouts-table-type-shipping_label": "shipping label",
    "document-layouts-table-type-packing_slip": "packing slip",
    "document-layouts-table-type-card": "card",
    "document-layouts-table-size-A4": "A4",
    "document-layouts-table-size-A5": "A5",
    "document-layouts-table-size-credit_card": "credit card",
    "document-layouts-table-size-custom": "custom",
    "document-layouts-table-orientation-portrait": "portrait",
    "document-layouts-table-orientation-landscape": "landscape",

    // document template add form
    "document-template-add-form-loading": "loading...",
    "document-template-add-form-name": "name",
    "document-template-add-form-name-placeholder": "template name",
    "document-template-add-form-layout": "layout",
    "document-template-add-form-supported-locales": "supported languages",
    "document-template-add-form-universal-caption": "if none selected, template will be saved as 'universal' (non-localized)",
    "document-template-add-form-objects": "objects",
    "document-template-add-form-select-layout-preview": "select a layout to preview",
    "document-template-add-form-download-preview": "download preview",
    "document-template-add-form-save": "save",
    "document-template-add-form-cancel": "cancel",
    "document-template-add-form-preview-lang": "language",
    "document-template-add-form-preview-output": "output",
    "document-template-add-form-preview-output-print": "print",
    "document-template-add-form-preview-output-digital": "digital",
    "document-template-add-form-preview-highlight-final-size": "highlight final size",
    "document-template-add-form-preview-highlight-margin": "highlight margin",
    "document-template-add-form-preview-highlight-bleed-box": "highlight bleed box",
    "document-template-add-form-preview-reset": "reset",
    "document-template-add-form-preview-rendering": "Rendering PDF...",
    "document-template-add-form-no-objects-to-edit": "No objects to edit. All objects are auto-generated.",
    "document-template-add-form-placeholders": "Placeholders: [VALID_TO], [VALID_FROM], [ORDER_ID], [ORDER_NUMBER], [PRODUCT_NAME], [FACE_VALUE]",
    "document-template-add-form-image-fit": "Image Fit",
    "document-template-add-form-image-fit-fill": "Fill (Cover)",
    "document-template-add-form-image-fit-fit": "Fit (Contain)",
    "document-template-add-form-image-fit-stretch": "Stretch (Distort)",
    "document-template-add-form-image-position": "Image Position",
    "document-template-add-form-image-position-top-left": "Top Left",
    "document-template-add-form-image-position-top-center": "Top Center",
    "document-template-add-form-image-position-top-right": "Top Right",
    "document-template-add-form-image-position-middle-left": "Middle Left",
    "document-template-add-form-image-position-middle-center": "Middle Center",
    "document-template-add-form-image-position-middle-right": "Middle Right",
    "document-template-add-form-image-position-bottom-left": "Bottom Left",
    "document-template-add-form-image-position-bottom-center": "Bottom Center",
    "document-template-add-form-image-position-bottom-right": "Bottom Right",
    "document-template-add-form-image-position-center": "Center",
    "document-template-add-form-image-position-custom": "Custom",
    "document-template-add-form-image-position-x": "X (%)",
    "document-template-add-form-image-position-y": "Y (%)",
    "document-template-add-form-alert-select-layout": "Please select a layout and fill in object values",
    "document-template-add-form-alert-download-error": "Error downloading preview:",

    // loyalty
    "loyalty": "loyalty",
    "view-title-loyalty": "loyalty",
    "view-title-loyalty-discounts": "discounts",
    "view-title-loyalty-discounts-add": "add discount",
    "view-title-loyalty-discounts-edit": "edit discount",
    "view-title-loyalty-discounts-detail": "discount detail",
    "view-title-loyalty-transactions": "transactions",
    "loyalty-discounts-table-col-name": "name",
    "loyalty-discounts-table-col-type": "type",
    "loyalty-discounts-table-col-value": "value",
    "loyalty-discounts-table-col-currency": "currency",
    "loyalty-discounts-table-col-enabled": "enabled",
    "loyalty-transactions-table-col-person": "person",
    "loyalty-transactions-table-col-type": "type",
    "loyalty-transactions-table-col-name": "name",
    "loyalty-transactions-table-col-bill": "bill",
    "loyalty-transactions-table-col-discount": "discount",
    "loyalty-transactions-table-col-bill-before": "bill before",
    "loyalty-transactions-table-col-amount": "amount",
    "loyalty-transactions-table-col-bill-after": "bill after",
    "loyalty-transactions-table-col-created": "created",
    "loyalty-transactions-table-col-status": "status",
    "loyalty-transactions-type-discount": "discount",
    "loyalty-transactions-type-cashback": "cashback",
    "loyalty-transactions-type-topup_bonus": "top-up bonus",
    "loyalty-transactions-type-points": "points",
    "loyalty-transactions-type-stamp": "stamp",
    "loyalty-transactions-type-reward": "reward",
    "loyalty-transactions-status-pending": "pending",
    "loyalty-transactions-status-success": "success",
    "loyalty-transactions-status-failed": "failed",
    "loyalty-transactions-status-canceled": "canceled",
    "loyalty-discounts-filter-placeholder": "search",
    "loyalty-discounts-add-button-label": "discount",
    "loyalty-discount-form-field-name-label": "name",
    "loyalty-discount-form-field-name-caption": "discount name",
    "loyalty-discount-form-field-slug-label": "slug",
    "loyalty-discount-form-field-slug-caption": "url slug",
    "loyalty-discount-form-field-description-label": "description",
    "loyalty-discount-form-field-description-caption": "discount description",
    "loyalty-discount-form-field-name-on-loyalty-card-label": "name on loyalty card",
    "loyalty-discount-form-field-name-on-loyalty-card-caption": "name displayed on loyalty program card",
    "loyalty-discount-form-field-type-label": "type",
    "loyalty-discount-form-field-type-caption": "discount type",
    "loyalty-discount-form-field-type-option-percentage": "percentage",
    "loyalty-discount-form-field-type-option-fixed-amount": "fixed amount",
    "loyalty-discount-form-field-value-label": "value",
    "loyalty-discount-form-field-value-caption": "discount value",
    "loyalty-discount-form-field-currency-label": "currency",
    "loyalty-discount-form-field-currency-caption": "currency",
    "loyalty-discount-form-field-scope-label": "scope",
    "loyalty-discount-form-field-scope-caption": "scope",
    "loyalty-discount-form-field-enabled-label": "enabled",
    "loyalty-discount-form-action-save-label": "save",
    "loyalty-discount-form-action-cancel-label": "cancel",
    "loyalty-stamp-card-form-field-enabled-label": "enabled",
    "loyalty-stamp-card-form-section-tracks": "tracks",
    "loyalty-stamp-card-form-action-add-track": "add track",
    "loyalty-stamp-card-form-track-stamps-required-label": "stamps required",
    "loyalty-stamp-card-form-track-stamps-required-caption": "Total slots on the card until reward (e.g. 7 for buy 6 get 1 free).",
    "loyalty-stamp-card-form-track-signup-stamps-label": "signup stamps",
    "loyalty-stamp-card-form-track-signup-stamps-caption": "Stamps credited when the customer joins this track on the join page.",
    "loyalty-stamp-card-form-track-image-set-key-label": "stamp image set key",
    "loyalty-stamp-card-form-track-image-set-key-caption": "Key into wallet pass config (stampImageSets). Defaults to track slug or \"default\".",
    "loyalty-stamp-card-form-track-product-ids-label": "product IDs",
    "loyalty-stamp-card-form-track-product-ids-caption": "Storyous product IDs, comma-separated. A line item matches if its product ID is listed.",
    "loyalty-stamp-card-form-track-category-ids-label": "category IDs",
    "loyalty-stamp-card-form-track-category-ids-caption": "Storyous category IDs, comma-separated. A line item matches if any of its categories is listed.",
    "loyalty-stamp-card-form-track-name-label": "track name",
    "loyalty-stamp-card-form-track-name-caption": "Name shown to customers (e.g. bread, coffee).",
    "loyalty-stamp-card-form-track-slug-label": "track slug",
    "loyalty-stamp-card-form-track-slug-caption": "Stable identifier for wallet images and stampImageSetKey.",
    "loyalty-stamp-card-list-col-name": "name",
    "loyalty-stamp-card-list-col-tracks": "tracks",
    "loyalty-stamp-card-list-col-enabled": "enabled",
    "loyalty-stamp-card-stats-active-instances": "active cards",
    "loyalty-stamp-card-stats-enrollments": "enrollments",
    "loyalty-stamp-card-detail-section-active-instances": "active customer cards",
    "loyalty-stamp-card-detail-section-activity": "recent activity",
    "loyalty-stamp-card-instances-col-person": "customer",
    "loyalty-stamp-card-instances-col-track": "track",
    "loyalty-stamp-card-instances-col-stamps": "stamps",
    "loyalty-stamp-card-instances-col-status": "status",
    "loyalty-stamp-card-instances-col-created": "created",
    "loyalty-stamp-card-activity-col-created": "created",
    "loyalty-stamp-card-activity-col-person": "customer",
    "loyalty-stamp-card-activity-col-instance": "card",
    "loyalty-stamp-card-activity-instance-n": "{n}. card",
    "loyalty-stamp-card-activity-col-track": "track",
    "loyalty-stamp-card-activity-col-type": "type",
    "loyalty-stamp-card-activity-col-delta": "stamps ±",
    "loyalty-stamp-card-activity-col-bill": "bill",
    "loyalty-stamp-card-activity-col-status": "status",
    "loyalty-stamp-card-instance-label-person": "customer",
    "loyalty-stamp-card-instance-label-track": "track",
    "loyalty-stamp-card-instance-label-status": "status",
    "loyalty-stamp-card-instance-label-stamps": "stamps",
    "loyalty-stamp-card-instance-label-created": "created",
    "loyalty-stamp-card-instance-action-back": "back to stamp card",
    "loyalty-stamp-card-instance-not-found": "stamp card instance not found",
    "view-title-loyalty-stamp-card-instance": "stamp card instance",
    "loyalty-stamp-card-track-action-view-activity": "view activity",
    "loyalty-stamp-card-track-action-back": "back to configuration",
    "loyalty-stamp-card-track-empty-instances": "No open customer cards on this track.",
    "loyalty-stamp-card-track-empty-activity":
      "No POS activity yet. Stamp and reward transactions appear here after Storyous crediting or redemption — signup stamps update the card only.",
    "loyalty-stamp-card-track-not-found": "track not found",
    "view-title-loyalty-stamp-card-track": "stamp card track",
    "loyalty-discount-detail-label-enabled": "enabled",
    "loyalty-discount-detail-label-name": "name",
    "loyalty-discount-detail-label-slug": "slug",
    "loyalty-discount-detail-label-description": "description",
    "loyalty-discount-detail-label-name-on-loyalty-card": "name on loyalty card",
    "loyalty-discount-detail-label-type": "type",
    "loyalty-discount-detail-label-value": "value",
    "loyalty-discount-detail-label-currency": "currency",
    "loyalty-discount-detail-action-enable": "enable",
    "loyalty-discount-detail-action-disable": "disable",
    "loyalty-discount-detail-action-edit": "edit",
    "loyalty-discount-detail-action-delete": "delete",
    "view-title-loyalty-join-pages": "join pages",
    "view-title-loyalty-join-pages-add": "add join page",
    "view-title-loyalty-join-pages-edit": "edit join page",
    "view-title-loyalty-join-pages-detail": "join page detail",
    "loyalty-join-pages-table-col-name": "name",
    "loyalty-join-pages-table-col-slug": "slug",
    "loyalty-join-pages-table-col-discount": "discount",
    "loyalty-join-pages-table-col-cashback": "cashback",
    "loyalty-join-pages-table-col-topup-bonus": "topup bonus",
    "loyalty-join-page-form-field-name-label": "name",
    "loyalty-join-page-form-field-name-caption": "internal, not visible to customers",
    "loyalty-join-page-form-field-slug-label": "slug",
    "loyalty-join-page-form-field-slug-caption": "page url, eg. yoursite.cz/loyalty/join/SLUG",
    "loyalty-join-page-form-field-title-label": "title",
    "loyalty-join-page-form-field-description-label": "description",
    "loyalty-join-page-form-field-discount-label": "discount",
    "loyalty-join-page-detail-section-basic": "basic info",
    "loyalty-join-page-detail-label-name": "name",
    "loyalty-join-page-detail-label-slug": "slug",
    "loyalty-join-page-detail-label-title": "title",
    "loyalty-join-page-detail-label-description": "description",
    "loyalty-join-page-detail-label-discount": "discount",
    "loyalty-join-page-detail-label-url": "url",
    "loyalty-join-page-detail-action-edit": "edit",
    "loyalty-join-page-form-action-save-label": "save",
    "loyalty-join-page-form-action-cancel-label": "cancel",
    "loyalty-join-page-form-field-name-placeholder": "walk-in customers",
    "loyalty-join-page-form-field-slug-placeholder": "walkin-customer",
    "loyalty-join-page-form-field-title-placeholder": "Join our loyalty program",
    "loyalty-join-page-form-field-description-placeholder": "You will get discount on every order. The more you spend, the more you receive.",
    "loyalty-join-page-form-field-discount-caption": "assigned discount after joining",
    "loyalty-join-page-auto-activate-discount-label": "auto activate discount",
    "loyalty-join-page-assign-discount-label": "assign discount",
    "loyalty-join-page-create-balance-label": "create balance",
    "loyalty-discount-status-pending": "pending",
    "loyalty-discount-status-active": "active",
    "loyalty-discount-join-page-origin": "from join page",
    "loyalty-discount-activate-action": "activate",
    "loyalty-discount-deactivate-action": "deactivate",

    // loyalty cashback
    "view-title-loyalty-cashbacks": "cashbacks",
    "view-title-loyalty-stamp-cards": "stamp cards",
    "loyalty-cashbacks-table-col-name": "name",
    "loyalty-cashbacks-table-col-type": "type",
    "loyalty-cashbacks-table-col-value": "value",
    "loyalty-cashbacks-table-col-expiration": "expiration",
    "loyalty-cashbacks-table-col-enabled": "enabled",
    "loyalty-cashback-form-field-name-label": "name",
    "loyalty-cashback-form-field-slug-label": "slug",
    "loyalty-cashback-form-field-description-label": "description",
    "loyalty-cashback-form-field-transaction-description-label": "transaction description",
    "loyalty-cashback-form-field-name-on-loyalty-card-label": "name on loyalty card",
    "loyalty-cashback-form-field-type-label": "type",
    "loyalty-cashback-form-field-type-option-percentage": "percentage",
    "loyalty-cashback-form-field-type-option-fixed-amount": "fixed amount",
    "loyalty-cashback-form-field-value-label": "value",
    "loyalty-cashback-form-field-value-calc-base-label": "base calculation",
    "loyalty-cashback-form-field-value-calc-base-caption": "what and how to compute the base for the percentage",
    "loyalty-cashback-form-field-calculation-rules-label": "calculation rules",
    "loyalty-cashback-form-field-calculation-rules-caption": "optionally narrow the calculation (payment methods, max cashback)",
    "loyalty-cashback-form-field-calculation-rules-payment-methods-hint": "calculate value from selected payment methods (e.g. cash only, card only)",
    "loyalty-cashback-form-field-base-filters-items-note": "only applies when calculating from items",
    "loyalty-cashback-form-field-base-filters-bill-note": "only applies when calculating from bill total",
    "loyalty-cashback-form-field-base-filters-irrelevant-note": "this filter only applies when calculating from items – change base or remove",
    "loyalty-cashback-form-field-value-calc-caption": "optionally add categories, min/max price, cap",
    "loyalty-cashback-form-field-value-calc-rule-label": "rule",
    "loyalty-cashback-form-field-value-calc-kind-label": "type",
    "loyalty-cashback-form-field-value-calc-categories-label": "include categories",
    "loyalty-cashback-form-field-value-calc-categories-hint": "which items to include in the calculation",
    "loyalty-cashback-form-field-value-calc-categories-placeholder": "load categories from POS integration",
    "loyalty-cashback-form-field-value-calc-categories-ids-placeholder": "category IDs (comma separated)",
    "loyalty-cashback-form-field-value-calc-from-label": "calculate from",
    "loyalty-cashback-form-field-value-calc-from-bill-total": "bill total",
    "loyalty-cashback-form-field-value-calc-from-items": "items",
    "loyalty-cashback-form-field-value-calc-taxes-label": "taxes",
    "loyalty-cashback-form-field-value-calc-taxes-included": "included",
    "loyalty-cashback-form-field-value-calc-taxes-excluded": "excluded",
    "loyalty-cashback-form-field-value-calc-discounts-label": "discounts",
    "loyalty-cashback-form-field-value-calc-discounts-before": "before",
    "loyalty-cashback-form-field-value-calc-discounts-after": "after",
    "loyalty-cashback-form-field-value-calc-tips-label": "tips",
    "loyalty-cashback-form-field-value-calc-tips-included": "included",
    "loyalty-cashback-form-field-value-calc-tips-excluded": "excluded",
    "loyalty-cashback-form-field-value-calc-min-bill-total-label": "min bill total (incl. tax)",
    "loyalty-cashback-form-field-value-calc-max-bill-total-label": "max bill total (incl. tax)",
    "loyalty-cashback-form-field-value-calc-payment-methods-label": "payment methods",
    "loyalty-cashback-form-field-payment-method-cash": "cash",
    "loyalty-cashback-form-field-payment-method-card": "card",
    "loyalty-cashback-form-field-payment-method-balance": "balance",
    "loyalty-cashback-form-field-payment-method-filter-label": "payment methods",
    "loyalty-cashback-form-field-payment-method-filter-caption": "bill portion for calculation",
    "loyalty-cashback-form-field-payment-method-filter-all": "full bill",
    "loyalty-cashback-form-field-payment-method-filter-include-only": "include only",
    "loyalty-cashback-form-field-payment-method-filter-exclude": "exclude selected",
    "loyalty-cashback-form-field-payment-methods-include-hint": "e.g. cash, card",
    "loyalty-cashback-form-field-payment-methods-exclude-hint": "e.g. balance",
    "loyalty-cashback-form-field-value-calc-min-price-pc-label": "min price / pc (incl. tax)",
    "loyalty-cashback-form-field-value-calc-max-price-pc-label": "max price / pc (incl. tax)",
    "loyalty-cashback-form-field-value-calc-excluded-items-label": "excluded items",
    "loyalty-cashback-form-field-value-calc-excluded-items-placeholder": "product/category IDs from POS (comma separated)",
    "loyalty-cashback-form-field-value-calc-min-quantity-label": "min quantity",
    "loyalty-cashback-form-field-value-calc-min-quantity-scope-label": "scope",
    "loyalty-cashback-form-field-value-calc-min-quantity-per-product": "per product",
    "loyalty-cashback-form-field-value-calc-min-quantity-all-products": "all products",
    "loyalty-cashback-form-field-value-calc-cap-label": "max cashback / bill",
    "loyalty-cashback-form-field-cap-enabled-label": "limit max cashback per bill",
    "loyalty-cashback-form-field-expiration-label": "expiration",
    "loyalty-cashback-form-field-expiration-option-p7d": "7 days",
    "loyalty-cashback-form-field-expiration-option-p14d": "14 days",
    "loyalty-cashback-form-field-expiration-option-p1m": "1 month",
    "loyalty-cashback-form-field-expiration-option-p3m": "3 months",
    "loyalty-cashback-form-field-expiration-option-p6m": "6 months",
    "loyalty-cashback-form-field-expiration-option-p1y": "1 year",
    "loyalty-cashback-form-field-expiration-option-p2y": "2 years",
    "loyalty-cashback-form-field-expiration-option-p3y": "3 years",
    "loyalty-cashback-form-field-expiration-option-p5y": "5 years",
    "loyalty-cashback-form-field-expiration-option-2099": "2099",
    "loyalty-cashback-form-field-apply-delay-label": "apply delay",
    "loyalty-cashback-form-field-apply-delay-caption": "when cashback is credited to the account",
    "loyalty-cashback-form-field-apply-delay-enabled-label": "apply delay",
    "loyalty-cashback-form-field-apply-delay-in-duration": "in",
    "loyalty-cashback-form-field-apply-delay-days": "days",
    "loyalty-cashback-form-field-apply-delay-hours": "hours",
    "loyalty-cashback-form-field-apply-delay-minutes": "minutes",
    "loyalty-cashback-form-field-apply-delay-next-day-today": "today at midnight",
    "loyalty-cashback-form-field-apply-delay-next-day-tomorrow": "tomorrow at midnight",
    "loyalty-cashback-form-field-apply-delay-next-day-in-n": "in %0 days",
    "loyalty-cashback-form-field-apply-delay-next-week-this": "end of this week",
    "loyalty-cashback-form-field-apply-delay-next-week-next": "end of next week",
    "loyalty-cashback-form-field-apply-delay-next-week-in-n": "end of week in %0 weeks",
    "loyalty-cashback-form-field-apply-delay-next-month-this": "end of this month",
    "loyalty-cashback-form-field-apply-delay-next-month-next": "end of next month",
    "loyalty-cashback-form-field-apply-delay-next-month-in-n": "end of month in %0 months",
    "loyalty-cashback-form-field-apply-delay-type-next-day": "at midnight (day)",
    "loyalty-cashback-form-field-apply-delay-type-next-week": "end of week",
    "loyalty-cashback-form-field-apply-delay-type-next-month": "end of month",
    "loyalty-cashback-form-field-apply-delay-offset-days-label": "days (0 = today, 1 = tomorrow)",
    "loyalty-cashback-form-field-apply-delay-offset-weeks-label": "weeks (0 = this week, 1 = next)",
    "loyalty-cashback-form-field-apply-delay-offset-months-label": "months (0 = this month, 1 = next)",
    "loyalty-cashback-form-field-timezone-display-label": "timezone",
    "loyalty-cashback-form-field-enabled-label": "enabled",
    "loyalty-cashback-form-field-applied-when-label": "applied when",
    "loyalty-cashback-form-field-applied-when-caption": "cashback is applied when all following rules are met",
    "loyalty-cashback-form-field-rules-label": "rules",
    "loyalty-cashback-form-field-rules-caption": "cashback is applied when all following rules are met",
    "loyalty-cashback-form-field-rule-label": "rule",
    "loyalty-cashback-form-field-rule-kind-label": "rule kind",
    "loyalty-cashback-form-field-trigger-bill-opened": "bill opened",
    "loyalty-cashback-form-field-trigger-bill-paid": "bill paid",
    "loyalty-cashback-form-field-rule-min-bill-total": "min bill total",
    "loyalty-cashback-form-field-rule-max-bill-total": "max bill total",
    "loyalty-cashback-form-field-rule-payment-methods": "payment methods",
    "loyalty-cashback-form-field-rule-min-quantity": "min quantity",
    "loyalty-cashback-form-field-rule-excluded-items": "excluded items",
    "loyalty-cashback-form-field-rule-category-filter": "bill must contain categories",
    "loyalty-cashback-form-field-rule-category-filter-hint": "bill must have at least one item from these categories",
    "loyalty-cashback-form-field-day-of-week-label": "day of week",
    "loyalty-cashback-form-field-day-mo": "mon",
    "loyalty-cashback-form-field-day-tu": "tue",
    "loyalty-cashback-form-field-day-we": "wed",
    "loyalty-cashback-form-field-day-th": "thu",
    "loyalty-cashback-form-field-day-fr": "fri",
    "loyalty-cashback-form-field-day-sa": "sat",
    "loyalty-cashback-form-field-day-su": "sun",
    "loyalty-cashback-form-field-time-from-label": "time from",
    "loyalty-cashback-form-field-time-to-label": "time to",
    "loyalty-cashback-form-field-timezone-label": "timezone",
    "loyalty-cashback-form-action-save-label": "save",
    "loyalty-cashback-form-action-cancel-label": "cancel",
    "loyalty-cashback-detail-label-enabled": "enabled",
    "loyalty-cashback-detail-label-name": "name",
    "loyalty-cashback-detail-label-slug": "slug",
    "loyalty-cashback-detail-label-description": "description",
    "loyalty-cashback-detail-label-name-on-loyalty-card": "name on loyalty card",
    "loyalty-cashback-detail-label-type": "type",
    "loyalty-cashback-detail-label-value": "value",
    "loyalty-cashback-detail-label-expiration": "expiration",
    "loyalty-cashback-detail-action-enable": "enable",
    "loyalty-cashback-detail-action-disable": "disable",
    "loyalty-cashback-detail-action-edit": "edit",
    "loyalty-join-page-assign-cashback-label": "assign cashback",
    "loyalty-join-page-assign-cashback-requires-balance-caption": "requires create balance",
    "loyalty-join-page-form-field-cashback-label": "cashback",
    "loyalty-join-page-form-field-cashback-caption": "assigned cashback after joining",
    "loyalty-join-page-auto-activate-cashback-label": "auto activate cashback",
    "loyalty-join-page-detail-label-cashback": "cashback",
    "loyalty-join-page-assign-topup-bonus-label": "assign topup bonus",
    "loyalty-join-page-assign-topup-bonus-requires-balance-caption": "requires create balance",
    "loyalty-join-page-assign-topup-bonus-requires-allowCredit-caption": "requires balance crediting capability",
    "loyalty-join-page-form-field-topup-bonus-label": "topup bonus",
    "loyalty-join-page-form-field-topup-bonus-caption": "assigned topup bonus after joining",
    "loyalty-join-page-auto-activate-topup-bonus-label": "auto activate topup bonus",
    "loyalty-join-page-detail-label-topup-bonus": "topup bonus",
    "loyalty-topup-bonus-status-active": "active",
    "loyalty-topup-bonus-status-pending": "pending",
    "loyalty-topup-bonus-activate-action": "activate",
    "loyalty-topup-bonus-join-page-origin": "from join page",
    "loyalty-cashback-status-pending": "pending",
    "loyalty-cashback-status-active": "active",
    "loyalty-cashback-join-page-origin": "from join page",
    "loyalty-cashback-activate-action": "activate",

    // loyalty topup bonus
    "view-title-loyalty-topup-bonuses": "top-up bonuses",
    "view-title-loyalty-topup-bonuses-add": "add top-up bonus",
    "view-title-loyalty-topup-bonuses-detail": "top-up bonus",
    "view-title-loyalty-topup-bonuses-edit": "edit top-up bonus",
    "loyalty-topup-bonuses-table-col-name": "name",
    "loyalty-topup-bonuses-table-col-type": "type",
    "loyalty-topup-bonuses-table-col-value": "value",
    "loyalty-topup-bonuses-table-col-channels": "channels",
    "loyalty-topup-bonuses-table-col-enabled": "enabled",
    "loyalty-topup-bonus-form-field-enabled-label": "enabled",
    "loyalty-topup-bonus-form-field-name-label": "name",
    "loyalty-topup-bonus-form-field-description-label": "description",
    "loyalty-topup-bonus-form-field-transaction-description-label": "transaction description",
    "loyalty-topup-bonus-form-field-type-label": "type",
    "loyalty-topup-bonus-form-field-type-option-percentage": "percentage",
    "loyalty-topup-bonus-form-field-type-option-fixed-amount": "fixed amount",
    "loyalty-topup-bonus-form-field-value-label": "value",
    "loyalty-topup-bonus-form-field-cap-label": "cap (max bonus per top-up)",
    "loyalty-topup-bonus-form-field-channels-label": "channels",
    "loyalty-topup-bonus-form-field-channels-caption": "allow list: apply only to selected channels (empty = all)",
    "loyalty-topup-bonus-form-field-channel-pos": "POS",
    "loyalty-topup-bonus-form-field-channel-storefront": "storefront",
    "loyalty-topup-bonus-form-field-balance-group-label": "balance group (optional)",
    "loyalty-topup-bonus-form-field-rules-label": "rules",
    "loyalty-topup-bonus-form-field-rules-caption": "bonus applies when all rules match",
    "loyalty-topup-bonus-form-field-rule-label": "rule",
    "loyalty-topup-bonus-form-field-rule-kind-label": "rule kind",
    "loyalty-topup-bonus-form-field-rule-valid-from": "valid from",
    "loyalty-topup-bonus-form-field-rule-valid-to": "valid to",
    "loyalty-topup-bonus-form-field-rule-min-topup-amount": "min top-up amount",
    "loyalty-topup-bonus-form-field-rule-max-topup-amount": "max top-up amount",
    "loyalty-topup-bonus-form-field-rule-day-of-week": "day of week + time",
    "loyalty-topup-bonus-form-field-rule-value-label": "value",
    "loyalty-topup-bonus-form-action-save-label": "save",
    "loyalty-topup-bonus-form-action-cancel-label": "cancel",
    "loyalty-topup-bonus-detail-label-enabled": "enabled",
    "loyalty-topup-bonus-detail-label-name": "name",
    "loyalty-topup-bonus-detail-label-type": "type",
    "loyalty-topup-bonus-detail-label-value": "value",
    "loyalty-topup-bonus-detail-label-cap": "cap",
    "loyalty-topup-bonus-detail-label-channels": "channels",
    "loyalty-topup-bonus-detail-label-balance-group": "balance group",
    "loyalty-topup-bonus-detail-action-enable": "enable",
    "loyalty-topup-bonus-detail-action-disable": "disable",
    "loyalty-topup-bonus-detail-action-edit": "edit",
    "loyalty-topup-bonus-detail-action-delete": "delete",

    // object fields - common
    "object-field-color-cmyk": "color (CMYK)",
    "object-field-qr-foreground-color": "QR code color",
    "object-field-qr-background-color": "background color",
  },
}
